import type * as Types from "./schema";

import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
const defaultOptions = {} as const;
export const UserTableFragmentDoc = /*#__PURE__*/ gql`
  fragment UserTable on User {
    id
    auth0Sub
    fullName
    portalOnboarded
    email
    userDatumById {
      countryForeignAddress
    }
    petitionsByBeneficiaryId(orderBy: PRIMARY_KEY_DESC) {
      nodes {
        id
        petitionerId
        visaClass
        status
        targetSubmissionDate
        companyByPetitionerId {
          dbaName
        }
      }
    }
  }
`;
export const CaseStrategyFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment CaseStrategyFragment on CaseStrategy {
    id
    nodeId
    userId
    userEmail
    strategy
    label
    updatedAt
  }
`;
export const CompanyEntityFragmentDoc = /*#__PURE__*/ gql`
  fragment CompanyEntity on Company {
    id
    dbaName
    bio
    legalName
    phoneNumber
    ein
    websiteUrl
    countryBusinessAddress
    cityBusinessAddress
    stateBusinessAddress
    streetNumberStreetNameBusinessAddress
    unitNumberBusinessAddress
    unitTypeBusinessAddress
    zipCodeBusinessAddress
    isBusinessAddressWorksite
    companyTypeOfBusiness
    currentNumberOfEmployees
    companyGrossAnnualIncome
    companyNetAnnualIncome
    companyDocumentsByCompanyId {
      nodes {
        type
        fileByFileId {
          id
          name
        }
      }
    }
    companyMembersByCompanyId {
      nodes {
        isAuthorizedSignatory
        role
        userByUserId {
          id
          fullName
        }
      }
    }
  }
`;
export const UserDatumFragmentDoc = /*#__PURE__*/ gql`
  fragment UserDatum on UserDatum {
    cityBirth
    cityForeignAddress
    cityOfIssuePassportOcr
    cityUsResidentialAddress
    countryBirth
    countryForeignAddress
    countryOfIssuePassportOcr
    placeOfBirthPassportOcr
    postalCodeForeignAddress
    provinceBirth
    provinceForeignAddress
    stateForeignAddress
    stateUsResidentialAddress
    streetNumberStreetNameForeignAddress
    streetNumberStreetNameUsResidentialAddress
    zipCodeUsResidentialAddress
    phoneNumber
    role
    linkedinUrl
    personalUrl
    dateOfBirth
    addresses
  }
`;
export const UserFragmentDoc = /*#__PURE__*/ gql`
  fragment User on User {
    id
    email
    bio
    firstName
    middleName
    lastName
    fullName
    archetype
    portalOnboarded
    userDatumById {
      ...UserDatum
    }
    companyMembersByUserId {
      nodes {
        companyByCompanyId {
          id
          dbaName
          portalOnboarded
          cityBusinessAddress
          countryBusinessAddress
          stateBusinessAddress
          streetNumberStreetNameBusinessAddress
          unitNumberBusinessAddress
          unitTypeBusinessAddress
          zipCodeBusinessAddress
          isBusinessAddressWorksite
        }
      }
    }
    adminByUserId {
      nodeId
    }
    petitionsByBeneficiaryId {
      totalCount
    }
  }
`;
export const ExhibitFragmentDoc = /*#__PURE__*/ gql`
  fragment Exhibit on Exhibit {
    id
    name
    description
    status
    parentExhibitId
    orderIndex
    ownedBy
    exhibitType
    metaData
    exhibitFilesByExhibitId {
      nodes {
        orderIndex
        fileByFileId {
          id
          name
          deleted
          createdAt
          mimeType
        }
      }
    }
  }
`;
export const ModuleFragmentDoc = /*#__PURE__*/ gql`
  fragment Module on Module {
    id
    name
    description
    type
    orderIndex
    exhibitsByModuleId(orderBy: ORDER_INDEX_ASC, condition: { visible: true }) {
      nodes {
        ...Exhibit
      }
    }
  }
`;
export const PetitionFragmentDoc = /*#__PURE__*/ gql`
  fragment Petition on Petition {
    id
    latestPetition
    companyByPetitionerId {
      dbaName
      id
    }
    petitionShippedDate
    status
    targetSubmissionDate
    uscisAddress
    trackingNumber
    uscisReceiptNumber
    uscisStatus
    filingType
    userByBeneficiaryId {
      id
      fullName
      userDatumById {
        countryForeignAddress
      }
      i94EntriesByUserId(orderBy: [DATE_OF_ENTRY_DESC], first: 1) {
        nodes {
          visaClass
          dateOfEntry
        }
      }
    }
    visaClass
    caseType
    modulesByPetitionId(
      orderBy: ORDER_INDEX_ASC
      condition: { visible: true }
    ) {
      nodes {
        ...Module
      }
    }
    metadata
    projectManagementStatus
    oaUserId
    csmUserId
    userByOaUserId {
      id
      fullName
      email
    }
    userByCsmUserId {
      id
      fullName
      email
    }
  }
`;
export const ExhibitFileSubDocument = /*#__PURE__*/ gql`
  subscription ExhibitFileSub($wsId: String!, $exhibitId: String!) {
    exhibitFilesUpdated(wsId: $wsId, id: $exhibitId) {
      id
    }
  }
`;

/**
 * __useExhibitFileSubSubscription__
 *
 * To run a query within a React component, call `useExhibitFileSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExhibitFileSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExhibitFileSubSubscription({
 *   variables: {
 *      wsId: // value for 'wsId'
 *      exhibitId: // value for 'exhibitId'
 *   },
 * });
 */
export function useExhibitFileSubSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types.ExhibitFileSubSubscription,
    Types.ExhibitFileSubSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    Types.ExhibitFileSubSubscription,
    Types.ExhibitFileSubSubscriptionVariables
  >(ExhibitFileSubDocument, options);
}
export type ExhibitFileSubSubscriptionHookResult = ReturnType<
  typeof useExhibitFileSubSubscription
>;
export type ExhibitFileSubSubscriptionResult =
  Apollo.SubscriptionResult<Types.ExhibitFileSubSubscription>;
export const AllAttorneysDocument = /*#__PURE__*/ gql`
  query AllAttorneys {
    allUsers(condition: { isAttorney: true }, orderBy: [FULL_NAME_ASC]) {
      nodes {
        id
        fullName
      }
    }
  }
`;

/**
 * __useAllAttorneysQuery__
 *
 * To run a query within a React component, call `useAllAttorneysQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAttorneysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAttorneysQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAttorneysQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AllAttorneysQuery,
    Types.AllAttorneysQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllAttorneysQuery,
    Types.AllAttorneysQueryVariables
  >(AllAttorneysDocument, options);
}
export function useAllAttorneysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllAttorneysQuery,
    Types.AllAttorneysQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllAttorneysQuery,
    Types.AllAttorneysQueryVariables
  >(AllAttorneysDocument, options);
}
export type AllAttorneysQueryHookResult = ReturnType<
  typeof useAllAttorneysQuery
>;
export type AllAttorneysLazyQueryHookResult = ReturnType<
  typeof useAllAttorneysLazyQuery
>;
export type AllAttorneysQueryResult = Apollo.QueryResult<
  Types.AllAttorneysQuery,
  Types.AllAttorneysQueryVariables
>;
export const AllContactsDocument = /*#__PURE__*/ gql`
  query AllContacts {
    allUsers {
      nodes {
        id
        fullName
      }
    }
  }
`;

/**
 * __useAllContactsQuery__
 *
 * To run a query within a React component, call `useAllContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllContactsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AllContactsQuery,
    Types.AllContactsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllContactsQuery,
    Types.AllContactsQueryVariables
  >(AllContactsDocument, options);
}
export function useAllContactsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllContactsQuery,
    Types.AllContactsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllContactsQuery,
    Types.AllContactsQueryVariables
  >(AllContactsDocument, options);
}
export type AllContactsQueryHookResult = ReturnType<typeof useAllContactsQuery>;
export type AllContactsLazyQueryHookResult = ReturnType<
  typeof useAllContactsLazyQuery
>;
export type AllContactsQueryResult = Apollo.QueryResult<
  Types.AllContactsQuery,
  Types.AllContactsQueryVariables
>;
export const AllValidContactsDocument = /*#__PURE__*/ gql`
  query AllValidContacts {
    allUsers {
      nodes {
        ...UserTable
      }
    }
  }
  ${UserTableFragmentDoc}
`;

/**
 * __useAllValidContactsQuery__
 *
 * To run a query within a React component, call `useAllValidContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllValidContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllValidContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllValidContactsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AllValidContactsQuery,
    Types.AllValidContactsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllValidContactsQuery,
    Types.AllValidContactsQueryVariables
  >(AllValidContactsDocument, options);
}
export function useAllValidContactsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllValidContactsQuery,
    Types.AllValidContactsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllValidContactsQuery,
    Types.AllValidContactsQueryVariables
  >(AllValidContactsDocument, options);
}
export type AllValidContactsQueryHookResult = ReturnType<
  typeof useAllValidContactsQuery
>;
export type AllValidContactsLazyQueryHookResult = ReturnType<
  typeof useAllValidContactsLazyQuery
>;
export type AllValidContactsQueryResult = Apollo.QueryResult<
  Types.AllValidContactsQuery,
  Types.AllValidContactsQueryVariables
>;
export const EditContactBioDocument = /*#__PURE__*/ gql`
  mutation EditContactBio($id: BigInt!, $bio: String!) {
    updateUserById(input: { id: $id, userPatch: { bio: $bio } }) {
      clientMutationId
    }
  }
`;
export type EditContactBioMutationFn = Apollo.MutationFunction<
  Types.EditContactBioMutation,
  Types.EditContactBioMutationVariables
>;

/**
 * __useEditContactBioMutation__
 *
 * To run a mutation, you first call `useEditContactBioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditContactBioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editContactBioMutation, { data, loading, error }] = useEditContactBioMutation({
 *   variables: {
 *      id: // value for 'id'
 *      bio: // value for 'bio'
 *   },
 * });
 */
export function useEditContactBioMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.EditContactBioMutation,
    Types.EditContactBioMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.EditContactBioMutation,
    Types.EditContactBioMutationVariables
  >(EditContactBioDocument, options);
}
export type EditContactBioMutationHookResult = ReturnType<
  typeof useEditContactBioMutation
>;
export type EditContactBioMutationResult =
  Apollo.MutationResult<Types.EditContactBioMutation>;
export type EditContactBioMutationOptions = Apollo.BaseMutationOptions<
  Types.EditContactBioMutation,
  Types.EditContactBioMutationVariables
>;
export const EditCompanyBioDocument = /*#__PURE__*/ gql`
  mutation EditCompanyBio($id: BigInt!, $bio: String!) {
    updateCompanyById(input: { id: $id, companyPatch: { bio: $bio } }) {
      clientMutationId
    }
  }
`;
export type EditCompanyBioMutationFn = Apollo.MutationFunction<
  Types.EditCompanyBioMutation,
  Types.EditCompanyBioMutationVariables
>;

/**
 * __useEditCompanyBioMutation__
 *
 * To run a mutation, you first call `useEditCompanyBioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompanyBioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompanyBioMutation, { data, loading, error }] = useEditCompanyBioMutation({
 *   variables: {
 *      id: // value for 'id'
 *      bio: // value for 'bio'
 *   },
 * });
 */
export function useEditCompanyBioMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.EditCompanyBioMutation,
    Types.EditCompanyBioMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.EditCompanyBioMutation,
    Types.EditCompanyBioMutationVariables
  >(EditCompanyBioDocument, options);
}
export type EditCompanyBioMutationHookResult = ReturnType<
  typeof useEditCompanyBioMutation
>;
export type EditCompanyBioMutationResult =
  Apollo.MutationResult<Types.EditCompanyBioMutation>;
export type EditCompanyBioMutationOptions = Apollo.BaseMutationOptions<
  Types.EditCompanyBioMutation,
  Types.EditCompanyBioMutationVariables
>;
export const PetitionSelectorDocument = /*#__PURE__*/ gql`
  query PetitionSelector {
    allPetitions {
      nodes {
        id
        visaClass
        status
        userByBeneficiaryId {
          id
          fullName
        }
        companyByPetitionerId {
          id
          dbaName
        }
      }
    }
  }
`;

/**
 * __usePetitionSelectorQuery__
 *
 * To run a query within a React component, call `usePetitionSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `usePetitionSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetitionSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function usePetitionSelectorQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.PetitionSelectorQuery,
    Types.PetitionSelectorQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PetitionSelectorQuery,
    Types.PetitionSelectorQueryVariables
  >(PetitionSelectorDocument, options);
}
export function usePetitionSelectorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PetitionSelectorQuery,
    Types.PetitionSelectorQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PetitionSelectorQuery,
    Types.PetitionSelectorQueryVariables
  >(PetitionSelectorDocument, options);
}
export type PetitionSelectorQueryHookResult = ReturnType<
  typeof usePetitionSelectorQuery
>;
export type PetitionSelectorLazyQueryHookResult = ReturnType<
  typeof usePetitionSelectorLazyQuery
>;
export type PetitionSelectorQueryResult = Apollo.QueryResult<
  Types.PetitionSelectorQuery,
  Types.PetitionSelectorQueryVariables
>;
export const BuilderHeaderDocument = /*#__PURE__*/ gql`
  query BuilderHeader($petitionId: BigInt!) {
    petitionById(id: $petitionId) {
      id
      visaClass
      uscisAddress
      attorneyUserId
      userByBeneficiaryId {
        id
        fullName
        email
      }
      companyByPetitionerId {
        id
        dbaName
      }
      modulesByPetitionId {
        nodes {
          id
          name
          exhibitsByModuleId {
            nodes {
              id
              status
            }
          }
        }
      }
    }
  }
`;

/**
 * __useBuilderHeaderQuery__
 *
 * To run a query within a React component, call `useBuilderHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuilderHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuilderHeaderQuery({
 *   variables: {
 *      petitionId: // value for 'petitionId'
 *   },
 * });
 */
export function useBuilderHeaderQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.BuilderHeaderQuery,
    Types.BuilderHeaderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.BuilderHeaderQuery,
    Types.BuilderHeaderQueryVariables
  >(BuilderHeaderDocument, options);
}
export function useBuilderHeaderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.BuilderHeaderQuery,
    Types.BuilderHeaderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.BuilderHeaderQuery,
    Types.BuilderHeaderQueryVariables
  >(BuilderHeaderDocument, options);
}
export type BuilderHeaderQueryHookResult = ReturnType<
  typeof useBuilderHeaderQuery
>;
export type BuilderHeaderLazyQueryHookResult = ReturnType<
  typeof useBuilderHeaderLazyQuery
>;
export type BuilderHeaderQueryResult = Apollo.QueryResult<
  Types.BuilderHeaderQuery,
  Types.BuilderHeaderQueryVariables
>;
export const CompiledPetitionsByPetitionIdDocument = /*#__PURE__*/ gql`
  query CompiledPetitionsByPetitionId($id: BigInt!) {
    petitionById(id: $id) {
      compiledPetitionsByPetitionId {
        nodes {
          createdAt
          displayName
          status
          userByCreatorId {
            fullName
          }
          fileByFileId {
            id
            mimeType
            userByOwnerId {
              fullName
            }
          }
        }
      }
    }
  }
`;

/**
 * __useCompiledPetitionsByPetitionIdQuery__
 *
 * To run a query within a React component, call `useCompiledPetitionsByPetitionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompiledPetitionsByPetitionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompiledPetitionsByPetitionIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompiledPetitionsByPetitionIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.CompiledPetitionsByPetitionIdQuery,
    Types.CompiledPetitionsByPetitionIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.CompiledPetitionsByPetitionIdQuery,
    Types.CompiledPetitionsByPetitionIdQueryVariables
  >(CompiledPetitionsByPetitionIdDocument, options);
}
export function useCompiledPetitionsByPetitionIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CompiledPetitionsByPetitionIdQuery,
    Types.CompiledPetitionsByPetitionIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.CompiledPetitionsByPetitionIdQuery,
    Types.CompiledPetitionsByPetitionIdQueryVariables
  >(CompiledPetitionsByPetitionIdDocument, options);
}
export type CompiledPetitionsByPetitionIdQueryHookResult = ReturnType<
  typeof useCompiledPetitionsByPetitionIdQuery
>;
export type CompiledPetitionsByPetitionIdLazyQueryHookResult = ReturnType<
  typeof useCompiledPetitionsByPetitionIdLazyQuery
>;
export type CompiledPetitionsByPetitionIdQueryResult = Apollo.QueryResult<
  Types.CompiledPetitionsByPetitionIdQuery,
  Types.CompiledPetitionsByPetitionIdQueryVariables
>;
export const PetitionMetadataByIdDocument = /*#__PURE__*/ gql`
  query PetitionMetadataById($id: BigInt!) {
    petitionById(id: $id) {
      metadata
    }
  }
`;

/**
 * __usePetitionMetadataByIdQuery__
 *
 * To run a query within a React component, call `usePetitionMetadataByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePetitionMetadataByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetitionMetadataByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePetitionMetadataByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PetitionMetadataByIdQuery,
    Types.PetitionMetadataByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PetitionMetadataByIdQuery,
    Types.PetitionMetadataByIdQueryVariables
  >(PetitionMetadataByIdDocument, options);
}
export function usePetitionMetadataByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PetitionMetadataByIdQuery,
    Types.PetitionMetadataByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PetitionMetadataByIdQuery,
    Types.PetitionMetadataByIdQueryVariables
  >(PetitionMetadataByIdDocument, options);
}
export type PetitionMetadataByIdQueryHookResult = ReturnType<
  typeof usePetitionMetadataByIdQuery
>;
export type PetitionMetadataByIdLazyQueryHookResult = ReturnType<
  typeof usePetitionMetadataByIdLazyQuery
>;
export type PetitionMetadataByIdQueryResult = Apollo.QueryResult<
  Types.PetitionMetadataByIdQuery,
  Types.PetitionMetadataByIdQueryVariables
>;
export const AllFilesForPetitionByIdDocument = /*#__PURE__*/ gql`
  query AllFilesForPetitionById($id: BigInt!) {
    petitionById(id: $id) {
      modulesByPetitionId {
        nodes {
          exhibitsByModuleId {
            nodes {
              name
              id
              exhibitFilesByExhibitId {
                nodes {
                  fileByFileId {
                    id
                    name
                    mimeType
                  }
                }
              }
            }
          }
        }
      }
      userByBeneficiaryId {
        immigrationDocumentsByOwnerId(orderBy: ORDER_INDEX_ASC) {
          nodes {
            type
            fileByFileId {
              id
              name
              mimeType
            }
          }
        }
      }
      companyByPetitionerId {
        companyDocumentsByCompanyId {
          nodes {
            type
            fileByFileId {
              id
              name
              mimeType
            }
          }
        }
      }
      petitionFormsByPetitionId {
        nodes {
          type
          fileByFileId {
            id
            name
            mimeType
          }
        }
      }
      petitionLettersByPetitionId {
        nodes {
          name
          fileByFinalFileId {
            name
            id
            mimeType
          }
        }
      }
    }
  }
`;

/**
 * __useAllFilesForPetitionByIdQuery__
 *
 * To run a query within a React component, call `useAllFilesForPetitionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFilesForPetitionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFilesForPetitionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAllFilesForPetitionByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.AllFilesForPetitionByIdQuery,
    Types.AllFilesForPetitionByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllFilesForPetitionByIdQuery,
    Types.AllFilesForPetitionByIdQueryVariables
  >(AllFilesForPetitionByIdDocument, options);
}
export function useAllFilesForPetitionByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllFilesForPetitionByIdQuery,
    Types.AllFilesForPetitionByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllFilesForPetitionByIdQuery,
    Types.AllFilesForPetitionByIdQueryVariables
  >(AllFilesForPetitionByIdDocument, options);
}
export type AllFilesForPetitionByIdQueryHookResult = ReturnType<
  typeof useAllFilesForPetitionByIdQuery
>;
export type AllFilesForPetitionByIdLazyQueryHookResult = ReturnType<
  typeof useAllFilesForPetitionByIdLazyQuery
>;
export type AllFilesForPetitionByIdQueryResult = Apollo.QueryResult<
  Types.AllFilesForPetitionByIdQuery,
  Types.AllFilesForPetitionByIdQueryVariables
>;
export const AllModuleTypesDocument = /*#__PURE__*/ gql`
  query AllModuleTypes {
    allModuleTypes {
      nodes {
        name
        id
        description
        inputs
      }
    }
  }
`;

/**
 * __useAllModuleTypesQuery__
 *
 * To run a query within a React component, call `useAllModuleTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllModuleTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllModuleTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllModuleTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AllModuleTypesQuery,
    Types.AllModuleTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllModuleTypesQuery,
    Types.AllModuleTypesQueryVariables
  >(AllModuleTypesDocument, options);
}
export function useAllModuleTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllModuleTypesQuery,
    Types.AllModuleTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllModuleTypesQuery,
    Types.AllModuleTypesQueryVariables
  >(AllModuleTypesDocument, options);
}
export type AllModuleTypesQueryHookResult = ReturnType<
  typeof useAllModuleTypesQuery
>;
export type AllModuleTypesLazyQueryHookResult = ReturnType<
  typeof useAllModuleTypesLazyQuery
>;
export type AllModuleTypesQueryResult = Apollo.QueryResult<
  Types.AllModuleTypesQuery,
  Types.AllModuleTypesQueryVariables
>;
export const ModuleByIdDocument = /*#__PURE__*/ gql`
  query ModuleById($id: BigInt!) {
    moduleById(id: $id) {
      id
      name
      description
      visible
      type
      compilerHideTitleRow
      exhibitsByModuleId(
        orderBy: ORDER_INDEX_ASC
        condition: { parentExhibitId: null }
      ) {
        nodes {
          id
        }
      }
    }
  }
`;

/**
 * __useModuleByIdQuery__
 *
 * To run a query within a React component, call `useModuleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useModuleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModuleByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useModuleByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.ModuleByIdQuery,
    Types.ModuleByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.ModuleByIdQuery, Types.ModuleByIdQueryVariables>(
    ModuleByIdDocument,
    options
  );
}
export function useModuleByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ModuleByIdQuery,
    Types.ModuleByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ModuleByIdQuery,
    Types.ModuleByIdQueryVariables
  >(ModuleByIdDocument, options);
}
export type ModuleByIdQueryHookResult = ReturnType<typeof useModuleByIdQuery>;
export type ModuleByIdLazyQueryHookResult = ReturnType<
  typeof useModuleByIdLazyQuery
>;
export type ModuleByIdQueryResult = Apollo.QueryResult<
  Types.ModuleByIdQuery,
  Types.ModuleByIdQueryVariables
>;
export const FileByIdDocument = /*#__PURE__*/ gql`
  query FileById($id: BigInt!) {
    fileById(id: $id) {
      id
      name
      mimeType
    }
  }
`;

/**
 * __useFileByIdQuery__
 *
 * To run a query within a React component, call `useFileByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFileByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FileByIdQuery,
    Types.FileByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.FileByIdQuery, Types.FileByIdQueryVariables>(
    FileByIdDocument,
    options
  );
}
export function useFileByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FileByIdQuery,
    Types.FileByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.FileByIdQuery, Types.FileByIdQueryVariables>(
    FileByIdDocument,
    options
  );
}
export type FileByIdQueryHookResult = ReturnType<typeof useFileByIdQuery>;
export type FileByIdLazyQueryHookResult = ReturnType<
  typeof useFileByIdLazyQuery
>;
export type FileByIdQueryResult = Apollo.QueryResult<
  Types.FileByIdQuery,
  Types.FileByIdQueryVariables
>;
export const ExhibitByIdDocument = /*#__PURE__*/ gql`
  query ExhibitById($id: BigInt!) {
    exhibitById(id: $id) {
      id
      name
      description
      orderIndex
      status
      ownedBy
      exhibitType
      visible
      compilerOverrideName
      index
      metaData
      metadata
      moduleByModuleId {
        id
        type
      }
      exhibitFilesByExhibitId(orderBy: ORDER_INDEX_ASC) {
        nodes {
          fileId
          orderIndex
          fileByFileId {
            id
            name
            mimeType
          }
        }
      }
    }
  }
`;

/**
 * __useExhibitByIdQuery__
 *
 * To run a query within a React component, call `useExhibitByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useExhibitByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExhibitByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExhibitByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.ExhibitByIdQuery,
    Types.ExhibitByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ExhibitByIdQuery,
    Types.ExhibitByIdQueryVariables
  >(ExhibitByIdDocument, options);
}
export function useExhibitByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ExhibitByIdQuery,
    Types.ExhibitByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ExhibitByIdQuery,
    Types.ExhibitByIdQueryVariables
  >(ExhibitByIdDocument, options);
}
export type ExhibitByIdQueryHookResult = ReturnType<typeof useExhibitByIdQuery>;
export type ExhibitByIdLazyQueryHookResult = ReturnType<
  typeof useExhibitByIdLazyQuery
>;
export type ExhibitByIdQueryResult = Apollo.QueryResult<
  Types.ExhibitByIdQuery,
  Types.ExhibitByIdQueryVariables
>;
export const SubexhibitsByIdDocument = /*#__PURE__*/ gql`
  query SubexhibitsById($parentExhibitId: BigInt!) {
    allExhibits(
      condition: { parentExhibitId: $parentExhibitId }
      orderBy: [ORDER_INDEX_ASC, ID_ASC]
    ) {
      nodes {
        id
      }
    }
  }
`;

/**
 * __useSubexhibitsByIdQuery__
 *
 * To run a query within a React component, call `useSubexhibitsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubexhibitsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubexhibitsByIdQuery({
 *   variables: {
 *      parentExhibitId: // value for 'parentExhibitId'
 *   },
 * });
 */
export function useSubexhibitsByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SubexhibitsByIdQuery,
    Types.SubexhibitsByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SubexhibitsByIdQuery,
    Types.SubexhibitsByIdQueryVariables
  >(SubexhibitsByIdDocument, options);
}
export function useSubexhibitsByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SubexhibitsByIdQuery,
    Types.SubexhibitsByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SubexhibitsByIdQuery,
    Types.SubexhibitsByIdQueryVariables
  >(SubexhibitsByIdDocument, options);
}
export type SubexhibitsByIdQueryHookResult = ReturnType<
  typeof useSubexhibitsByIdQuery
>;
export type SubexhibitsByIdLazyQueryHookResult = ReturnType<
  typeof useSubexhibitsByIdLazyQuery
>;
export type SubexhibitsByIdQueryResult = Apollo.QueryResult<
  Types.SubexhibitsByIdQuery,
  Types.SubexhibitsByIdQueryVariables
>;
export const UserCaseStrategyDocument = /*#__PURE__*/ gql`
  query UserCaseStrategy(
    $userEmail: String
    $userId: BigInt
    $count: Int = 15
  ) {
    allCaseStrategies(
      condition: { userId: $userId, userEmail: $userEmail }
      orderBy: [CREATED_AT_DESC]
      last: $count
    ) {
      nodes {
        ...CaseStrategyFragment
      }
    }
  }
  ${CaseStrategyFragmentFragmentDoc}
`;

/**
 * __useUserCaseStrategyQuery__
 *
 * To run a query within a React component, call `useUserCaseStrategyQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCaseStrategyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCaseStrategyQuery({
 *   variables: {
 *      userEmail: // value for 'userEmail'
 *      userId: // value for 'userId'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useUserCaseStrategyQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.UserCaseStrategyQuery,
    Types.UserCaseStrategyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.UserCaseStrategyQuery,
    Types.UserCaseStrategyQueryVariables
  >(UserCaseStrategyDocument, options);
}
export function useUserCaseStrategyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.UserCaseStrategyQuery,
    Types.UserCaseStrategyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.UserCaseStrategyQuery,
    Types.UserCaseStrategyQueryVariables
  >(UserCaseStrategyDocument, options);
}
export type UserCaseStrategyQueryHookResult = ReturnType<
  typeof useUserCaseStrategyQuery
>;
export type UserCaseStrategyLazyQueryHookResult = ReturnType<
  typeof useUserCaseStrategyLazyQuery
>;
export type UserCaseStrategyQueryResult = Apollo.QueryResult<
  Types.UserCaseStrategyQuery,
  Types.UserCaseStrategyQueryVariables
>;
export const AllUserCaseStrategyDocument = /*#__PURE__*/ gql`
  query AllUserCaseStrategy {
    allCaseStrategies(orderBy: [CREATED_AT_DESC]) {
      nodes {
        ...CaseStrategyFragment
      }
    }
  }
  ${CaseStrategyFragmentFragmentDoc}
`;

/**
 * __useAllUserCaseStrategyQuery__
 *
 * To run a query within a React component, call `useAllUserCaseStrategyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserCaseStrategyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUserCaseStrategyQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllUserCaseStrategyQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AllUserCaseStrategyQuery,
    Types.AllUserCaseStrategyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllUserCaseStrategyQuery,
    Types.AllUserCaseStrategyQueryVariables
  >(AllUserCaseStrategyDocument, options);
}
export function useAllUserCaseStrategyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllUserCaseStrategyQuery,
    Types.AllUserCaseStrategyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllUserCaseStrategyQuery,
    Types.AllUserCaseStrategyQueryVariables
  >(AllUserCaseStrategyDocument, options);
}
export type AllUserCaseStrategyQueryHookResult = ReturnType<
  typeof useAllUserCaseStrategyQuery
>;
export type AllUserCaseStrategyLazyQueryHookResult = ReturnType<
  typeof useAllUserCaseStrategyLazyQuery
>;
export type AllUserCaseStrategyQueryResult = Apollo.QueryResult<
  Types.AllUserCaseStrategyQuery,
  Types.AllUserCaseStrategyQueryVariables
>;
export const CreateExhibitFileDocument = /*#__PURE__*/ gql`
  mutation CreateExhibitFile($input: CreateExhibitFileInput!) {
    createExhibitFile(input: $input) {
      clientMutationId
    }
  }
`;
export type CreateExhibitFileMutationFn = Apollo.MutationFunction<
  Types.CreateExhibitFileMutation,
  Types.CreateExhibitFileMutationVariables
>;

/**
 * __useCreateExhibitFileMutation__
 *
 * To run a mutation, you first call `useCreateExhibitFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExhibitFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExhibitFileMutation, { data, loading, error }] = useCreateExhibitFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExhibitFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateExhibitFileMutation,
    Types.CreateExhibitFileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateExhibitFileMutation,
    Types.CreateExhibitFileMutationVariables
  >(CreateExhibitFileDocument, options);
}
export type CreateExhibitFileMutationHookResult = ReturnType<
  typeof useCreateExhibitFileMutation
>;
export type CreateExhibitFileMutationResult =
  Apollo.MutationResult<Types.CreateExhibitFileMutation>;
export type CreateExhibitFileMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateExhibitFileMutation,
  Types.CreateExhibitFileMutationVariables
>;
export const CreateExhibitDocument = /*#__PURE__*/ gql`
  mutation CreateExhibit($input: CreateExhibitInput!) {
    createExhibit(input: $input) {
      clientMutationId
    }
  }
`;
export type CreateExhibitMutationFn = Apollo.MutationFunction<
  Types.CreateExhibitMutation,
  Types.CreateExhibitMutationVariables
>;

/**
 * __useCreateExhibitMutation__
 *
 * To run a mutation, you first call `useCreateExhibitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExhibitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExhibitMutation, { data, loading, error }] = useCreateExhibitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExhibitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateExhibitMutation,
    Types.CreateExhibitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateExhibitMutation,
    Types.CreateExhibitMutationVariables
  >(CreateExhibitDocument, options);
}
export type CreateExhibitMutationHookResult = ReturnType<
  typeof useCreateExhibitMutation
>;
export type CreateExhibitMutationResult =
  Apollo.MutationResult<Types.CreateExhibitMutation>;
export type CreateExhibitMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateExhibitMutation,
  Types.CreateExhibitMutationVariables
>;
export const CreateModuleDocument = /*#__PURE__*/ gql`
  mutation CreateModule($input: CreateModuleInput!) {
    createModule(input: $input) {
      clientMutationId
    }
  }
`;
export type CreateModuleMutationFn = Apollo.MutationFunction<
  Types.CreateModuleMutation,
  Types.CreateModuleMutationVariables
>;

/**
 * __useCreateModuleMutation__
 *
 * To run a mutation, you first call `useCreateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModuleMutation, { data, loading, error }] = useCreateModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateModuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateModuleMutation,
    Types.CreateModuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateModuleMutation,
    Types.CreateModuleMutationVariables
  >(CreateModuleDocument, options);
}
export type CreateModuleMutationHookResult = ReturnType<
  typeof useCreateModuleMutation
>;
export type CreateModuleMutationResult =
  Apollo.MutationResult<Types.CreateModuleMutation>;
export type CreateModuleMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateModuleMutation,
  Types.CreateModuleMutationVariables
>;
export const CreatePetitionFormDocument = /*#__PURE__*/ gql`
  mutation CreatePetitionForm($input: CreatePetitionFormInput!) {
    createPetitionForm(input: $input) {
      clientMutationId
    }
  }
`;
export type CreatePetitionFormMutationFn = Apollo.MutationFunction<
  Types.CreatePetitionFormMutation,
  Types.CreatePetitionFormMutationVariables
>;

/**
 * __useCreatePetitionFormMutation__
 *
 * To run a mutation, you first call `useCreatePetitionFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePetitionFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPetitionFormMutation, { data, loading, error }] = useCreatePetitionFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePetitionFormMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreatePetitionFormMutation,
    Types.CreatePetitionFormMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreatePetitionFormMutation,
    Types.CreatePetitionFormMutationVariables
  >(CreatePetitionFormDocument, options);
}
export type CreatePetitionFormMutationHookResult = ReturnType<
  typeof useCreatePetitionFormMutation
>;
export type CreatePetitionFormMutationResult =
  Apollo.MutationResult<Types.CreatePetitionFormMutation>;
export type CreatePetitionFormMutationOptions = Apollo.BaseMutationOptions<
  Types.CreatePetitionFormMutation,
  Types.CreatePetitionFormMutationVariables
>;
export const UpdatePetitionDocument = /*#__PURE__*/ gql`
  mutation UpdatePetition($input: UpdatePetitionByIdInput!) {
    updatePetitionById(input: $input) {
      clientMutationId
    }
  }
`;
export type UpdatePetitionMutationFn = Apollo.MutationFunction<
  Types.UpdatePetitionMutation,
  Types.UpdatePetitionMutationVariables
>;

/**
 * __useUpdatePetitionMutation__
 *
 * To run a mutation, you first call `useUpdatePetitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePetitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePetitionMutation, { data, loading, error }] = useUpdatePetitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePetitionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdatePetitionMutation,
    Types.UpdatePetitionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdatePetitionMutation,
    Types.UpdatePetitionMutationVariables
  >(UpdatePetitionDocument, options);
}
export type UpdatePetitionMutationHookResult = ReturnType<
  typeof useUpdatePetitionMutation
>;
export type UpdatePetitionMutationResult =
  Apollo.MutationResult<Types.UpdatePetitionMutation>;
export type UpdatePetitionMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdatePetitionMutation,
  Types.UpdatePetitionMutationVariables
>;
export const UpdateMultipleExhibitFilesDocument = /*#__PURE__*/ gql`
  mutation UpdateMultipleExhibitFiles(
    $input: UpdateMultipleExhibitFilesInput!
  ) {
    updateMultipleExhibitFiles(input: $input) {
      results {
        exhibitId
        fileId
        orderIndex
      }
    }
  }
`;
export type UpdateMultipleExhibitFilesMutationFn = Apollo.MutationFunction<
  Types.UpdateMultipleExhibitFilesMutation,
  Types.UpdateMultipleExhibitFilesMutationVariables
>;

/**
 * __useUpdateMultipleExhibitFilesMutation__
 *
 * To run a mutation, you first call `useUpdateMultipleExhibitFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMultipleExhibitFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMultipleExhibitFilesMutation, { data, loading, error }] = useUpdateMultipleExhibitFilesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMultipleExhibitFilesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateMultipleExhibitFilesMutation,
    Types.UpdateMultipleExhibitFilesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateMultipleExhibitFilesMutation,
    Types.UpdateMultipleExhibitFilesMutationVariables
  >(UpdateMultipleExhibitFilesDocument, options);
}
export type UpdateMultipleExhibitFilesMutationHookResult = ReturnType<
  typeof useUpdateMultipleExhibitFilesMutation
>;
export type UpdateMultipleExhibitFilesMutationResult =
  Apollo.MutationResult<Types.UpdateMultipleExhibitFilesMutation>;
export type UpdateMultipleExhibitFilesMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateMultipleExhibitFilesMutation,
    Types.UpdateMultipleExhibitFilesMutationVariables
  >;
export const UpdateMultipleExhibitsDocument = /*#__PURE__*/ gql`
  mutation updateMultipleExhibits($input: UpdateMultipleExhibitsOrderInput!) {
    updateMultipleExhibitsOrder(input: $input) {
      results {
        exhibitId
        orderIndex
      }
    }
  }
`;
export type UpdateMultipleExhibitsMutationFn = Apollo.MutationFunction<
  Types.UpdateMultipleExhibitsMutation,
  Types.UpdateMultipleExhibitsMutationVariables
>;

/**
 * __useUpdateMultipleExhibitsMutation__
 *
 * To run a mutation, you first call `useUpdateMultipleExhibitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMultipleExhibitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMultipleExhibitsMutation, { data, loading, error }] = useUpdateMultipleExhibitsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMultipleExhibitsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateMultipleExhibitsMutation,
    Types.UpdateMultipleExhibitsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateMultipleExhibitsMutation,
    Types.UpdateMultipleExhibitsMutationVariables
  >(UpdateMultipleExhibitsDocument, options);
}
export type UpdateMultipleExhibitsMutationHookResult = ReturnType<
  typeof useUpdateMultipleExhibitsMutation
>;
export type UpdateMultipleExhibitsMutationResult =
  Apollo.MutationResult<Types.UpdateMultipleExhibitsMutation>;
export type UpdateMultipleExhibitsMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateMultipleExhibitsMutation,
  Types.UpdateMultipleExhibitsMutationVariables
>;
export const UpdateMultipleModulesDocument = /*#__PURE__*/ gql`
  mutation UpdateMultipleModules($input: UpdateMultipleModuleOrderInput!) {
    updateMultipleModuleOrder(input: $input) {
      results {
        moduleId
      }
    }
  }
`;
export type UpdateMultipleModulesMutationFn = Apollo.MutationFunction<
  Types.UpdateMultipleModulesMutation,
  Types.UpdateMultipleModulesMutationVariables
>;

/**
 * __useUpdateMultipleModulesMutation__
 *
 * To run a mutation, you first call `useUpdateMultipleModulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMultipleModulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMultipleModulesMutation, { data, loading, error }] = useUpdateMultipleModulesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMultipleModulesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateMultipleModulesMutation,
    Types.UpdateMultipleModulesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateMultipleModulesMutation,
    Types.UpdateMultipleModulesMutationVariables
  >(UpdateMultipleModulesDocument, options);
}
export type UpdateMultipleModulesMutationHookResult = ReturnType<
  typeof useUpdateMultipleModulesMutation
>;
export type UpdateMultipleModulesMutationResult =
  Apollo.MutationResult<Types.UpdateMultipleModulesMutation>;
export type UpdateMultipleModulesMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateMultipleModulesMutation,
  Types.UpdateMultipleModulesMutationVariables
>;
export const UpdatePetitionFormDocument = /*#__PURE__*/ gql`
  mutation UpdatePetitionForm($input: UpdatePetitionFormByIdInput!) {
    updatePetitionFormById(input: $input) {
      clientMutationId
    }
  }
`;
export type UpdatePetitionFormMutationFn = Apollo.MutationFunction<
  Types.UpdatePetitionFormMutation,
  Types.UpdatePetitionFormMutationVariables
>;

/**
 * __useUpdatePetitionFormMutation__
 *
 * To run a mutation, you first call `useUpdatePetitionFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePetitionFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePetitionFormMutation, { data, loading, error }] = useUpdatePetitionFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePetitionFormMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdatePetitionFormMutation,
    Types.UpdatePetitionFormMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdatePetitionFormMutation,
    Types.UpdatePetitionFormMutationVariables
  >(UpdatePetitionFormDocument, options);
}
export type UpdatePetitionFormMutationHookResult = ReturnType<
  typeof useUpdatePetitionFormMutation
>;
export type UpdatePetitionFormMutationResult =
  Apollo.MutationResult<Types.UpdatePetitionFormMutation>;
export type UpdatePetitionFormMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdatePetitionFormMutation,
  Types.UpdatePetitionFormMutationVariables
>;
export const UnlinkExhibitFileDocument = /*#__PURE__*/ gql`
  mutation UnlinkExhibitFile(
    $input: DeleteExhibitFileByExhibitIdAndFileIdInput!
  ) {
    deleteExhibitFileByExhibitIdAndFileId(input: $input) {
      exhibitFile {
        fileId
      }
    }
  }
`;
export type UnlinkExhibitFileMutationFn = Apollo.MutationFunction<
  Types.UnlinkExhibitFileMutation,
  Types.UnlinkExhibitFileMutationVariables
>;

/**
 * __useUnlinkExhibitFileMutation__
 *
 * To run a mutation, you first call `useUnlinkExhibitFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkExhibitFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkExhibitFileMutation, { data, loading, error }] = useUnlinkExhibitFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkExhibitFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UnlinkExhibitFileMutation,
    Types.UnlinkExhibitFileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UnlinkExhibitFileMutation,
    Types.UnlinkExhibitFileMutationVariables
  >(UnlinkExhibitFileDocument, options);
}
export type UnlinkExhibitFileMutationHookResult = ReturnType<
  typeof useUnlinkExhibitFileMutation
>;
export type UnlinkExhibitFileMutationResult =
  Apollo.MutationResult<Types.UnlinkExhibitFileMutation>;
export type UnlinkExhibitFileMutationOptions = Apollo.BaseMutationOptions<
  Types.UnlinkExhibitFileMutation,
  Types.UnlinkExhibitFileMutationVariables
>;
export const DeleteUserDocumentDocument = /*#__PURE__*/ gql`
  mutation DeleteUserDocument(
    $input: DeleteUserDocumentByUserIdAndFileIdInput!
  ) {
    deleteUserDocumentByUserIdAndFileId(input: $input) {
      clientMutationId
      deletedUserDocumentId
    }
  }
`;
export type DeleteUserDocumentMutationFn = Apollo.MutationFunction<
  Types.DeleteUserDocumentMutation,
  Types.DeleteUserDocumentMutationVariables
>;

/**
 * __useDeleteUserDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteUserDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserDocumentMutation, { data, loading, error }] = useDeleteUserDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteUserDocumentMutation,
    Types.DeleteUserDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DeleteUserDocumentMutation,
    Types.DeleteUserDocumentMutationVariables
  >(DeleteUserDocumentDocument, options);
}
export type DeleteUserDocumentMutationHookResult = ReturnType<
  typeof useDeleteUserDocumentMutation
>;
export type DeleteUserDocumentMutationResult =
  Apollo.MutationResult<Types.DeleteUserDocumentMutation>;
export type DeleteUserDocumentMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteUserDocumentMutation,
  Types.DeleteUserDocumentMutationVariables
>;
export const DeleteImmigrationDocumentDocument = /*#__PURE__*/ gql`
  mutation DeleteImmigrationDocument(
    $input: DeleteImmigrationDocumentByOwnerIdAndFileIdInput!
  ) {
    deleteImmigrationDocumentByOwnerIdAndFileId(input: $input) {
      clientMutationId
      deletedImmigrationDocumentId
    }
  }
`;
export type DeleteImmigrationDocumentMutationFn = Apollo.MutationFunction<
  Types.DeleteImmigrationDocumentMutation,
  Types.DeleteImmigrationDocumentMutationVariables
>;

/**
 * __useDeleteImmigrationDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteImmigrationDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImmigrationDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImmigrationDocumentMutation, { data, loading, error }] = useDeleteImmigrationDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteImmigrationDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteImmigrationDocumentMutation,
    Types.DeleteImmigrationDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DeleteImmigrationDocumentMutation,
    Types.DeleteImmigrationDocumentMutationVariables
  >(DeleteImmigrationDocumentDocument, options);
}
export type DeleteImmigrationDocumentMutationHookResult = ReturnType<
  typeof useDeleteImmigrationDocumentMutation
>;
export type DeleteImmigrationDocumentMutationResult =
  Apollo.MutationResult<Types.DeleteImmigrationDocumentMutation>;
export type DeleteImmigrationDocumentMutationOptions =
  Apollo.BaseMutationOptions<
    Types.DeleteImmigrationDocumentMutation,
    Types.DeleteImmigrationDocumentMutationVariables
  >;
export const DeleteCompanyDocumentDocument = /*#__PURE__*/ gql`
  mutation DeleteCompanyDocument(
    $input: DeleteCompanyDocumentByCompanyIdAndFileIdInput!
  ) {
    deleteCompanyDocumentByCompanyIdAndFileId(input: $input) {
      clientMutationId
      deletedCompanyDocumentId
    }
  }
`;
export type DeleteCompanyDocumentMutationFn = Apollo.MutationFunction<
  Types.DeleteCompanyDocumentMutation,
  Types.DeleteCompanyDocumentMutationVariables
>;

/**
 * __useDeleteCompanyDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyDocumentMutation, { data, loading, error }] = useDeleteCompanyDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCompanyDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteCompanyDocumentMutation,
    Types.DeleteCompanyDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DeleteCompanyDocumentMutation,
    Types.DeleteCompanyDocumentMutationVariables
  >(DeleteCompanyDocumentDocument, options);
}
export type DeleteCompanyDocumentMutationHookResult = ReturnType<
  typeof useDeleteCompanyDocumentMutation
>;
export type DeleteCompanyDocumentMutationResult =
  Apollo.MutationResult<Types.DeleteCompanyDocumentMutation>;
export type DeleteCompanyDocumentMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteCompanyDocumentMutation,
  Types.DeleteCompanyDocumentMutationVariables
>;
export const DeleteModuleDocument = /*#__PURE__*/ gql`
  mutation DeleteModule($input: DeleteModuleByIdInput!) {
    deleteModuleById(input: $input) {
      clientMutationId
    }
  }
`;
export type DeleteModuleMutationFn = Apollo.MutationFunction<
  Types.DeleteModuleMutation,
  Types.DeleteModuleMutationVariables
>;

/**
 * __useDeleteModuleMutation__
 *
 * To run a mutation, you first call `useDeleteModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModuleMutation, { data, loading, error }] = useDeleteModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteModuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteModuleMutation,
    Types.DeleteModuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DeleteModuleMutation,
    Types.DeleteModuleMutationVariables
  >(DeleteModuleDocument, options);
}
export type DeleteModuleMutationHookResult = ReturnType<
  typeof useDeleteModuleMutation
>;
export type DeleteModuleMutationResult =
  Apollo.MutationResult<Types.DeleteModuleMutation>;
export type DeleteModuleMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteModuleMutation,
  Types.DeleteModuleMutationVariables
>;
export const DeleteExhibitDocument = /*#__PURE__*/ gql`
  mutation DeleteExhibit($input: DeleteExhibitByIdInput!) {
    deleteExhibitById(input: $input) {
      clientMutationId
    }
  }
`;
export type DeleteExhibitMutationFn = Apollo.MutationFunction<
  Types.DeleteExhibitMutation,
  Types.DeleteExhibitMutationVariables
>;

/**
 * __useDeleteExhibitMutation__
 *
 * To run a mutation, you first call `useDeleteExhibitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExhibitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExhibitMutation, { data, loading, error }] = useDeleteExhibitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteExhibitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteExhibitMutation,
    Types.DeleteExhibitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DeleteExhibitMutation,
    Types.DeleteExhibitMutationVariables
  >(DeleteExhibitDocument, options);
}
export type DeleteExhibitMutationHookResult = ReturnType<
  typeof useDeleteExhibitMutation
>;
export type DeleteExhibitMutationResult =
  Apollo.MutationResult<Types.DeleteExhibitMutation>;
export type DeleteExhibitMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteExhibitMutation,
  Types.DeleteExhibitMutationVariables
>;
export const DeletePetitionFormDocument = /*#__PURE__*/ gql`
  mutation DeletePetitionForm($input: DeletePetitionFormByIdInput!) {
    deletePetitionFormById(input: $input) {
      clientMutationId
    }
  }
`;
export type DeletePetitionFormMutationFn = Apollo.MutationFunction<
  Types.DeletePetitionFormMutation,
  Types.DeletePetitionFormMutationVariables
>;

/**
 * __useDeletePetitionFormMutation__
 *
 * To run a mutation, you first call `useDeletePetitionFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePetitionFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePetitionFormMutation, { data, loading, error }] = useDeletePetitionFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePetitionFormMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeletePetitionFormMutation,
    Types.DeletePetitionFormMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DeletePetitionFormMutation,
    Types.DeletePetitionFormMutationVariables
  >(DeletePetitionFormDocument, options);
}
export type DeletePetitionFormMutationHookResult = ReturnType<
  typeof useDeletePetitionFormMutation
>;
export type DeletePetitionFormMutationResult =
  Apollo.MutationResult<Types.DeletePetitionFormMutation>;
export type DeletePetitionFormMutationOptions = Apollo.BaseMutationOptions<
  Types.DeletePetitionFormMutation,
  Types.DeletePetitionFormMutationVariables
>;
export const PetitionBuilderExhibitFilesSubDocument = /*#__PURE__*/ gql`
  subscription PetitionBuilderExhibitFilesSub($exhibitId: String!) {
    exhibitFilesBuilderUpdated(id: $exhibitId) {
      id
    }
  }
`;

/**
 * __usePetitionBuilderExhibitFilesSubSubscription__
 *
 * To run a query within a React component, call `usePetitionBuilderExhibitFilesSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePetitionBuilderExhibitFilesSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetitionBuilderExhibitFilesSubSubscription({
 *   variables: {
 *      exhibitId: // value for 'exhibitId'
 *   },
 * });
 */
export function usePetitionBuilderExhibitFilesSubSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types.PetitionBuilderExhibitFilesSubSubscription,
    Types.PetitionBuilderExhibitFilesSubSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    Types.PetitionBuilderExhibitFilesSubSubscription,
    Types.PetitionBuilderExhibitFilesSubSubscriptionVariables
  >(PetitionBuilderExhibitFilesSubDocument, options);
}
export type PetitionBuilderExhibitFilesSubSubscriptionHookResult = ReturnType<
  typeof usePetitionBuilderExhibitFilesSubSubscription
>;
export type PetitionBuilderExhibitFilesSubSubscriptionResult =
  Apollo.SubscriptionResult<Types.PetitionBuilderExhibitFilesSubSubscription>;
export const PetitionBuilderExhibitSubDocument = /*#__PURE__*/ gql`
  subscription PetitionBuilderExhibitSub($exhibitId: String!) {
    exhibitsBuilderUpdated(id: $exhibitId) {
      id
    }
  }
`;

/**
 * __usePetitionBuilderExhibitSubSubscription__
 *
 * To run a query within a React component, call `usePetitionBuilderExhibitSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePetitionBuilderExhibitSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetitionBuilderExhibitSubSubscription({
 *   variables: {
 *      exhibitId: // value for 'exhibitId'
 *   },
 * });
 */
export function usePetitionBuilderExhibitSubSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types.PetitionBuilderExhibitSubSubscription,
    Types.PetitionBuilderExhibitSubSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    Types.PetitionBuilderExhibitSubSubscription,
    Types.PetitionBuilderExhibitSubSubscriptionVariables
  >(PetitionBuilderExhibitSubDocument, options);
}
export type PetitionBuilderExhibitSubSubscriptionHookResult = ReturnType<
  typeof usePetitionBuilderExhibitSubSubscription
>;
export type PetitionBuilderExhibitSubSubscriptionResult =
  Apollo.SubscriptionResult<Types.PetitionBuilderExhibitSubSubscription>;
export const PetitionBuilderModuleSubDocument = /*#__PURE__*/ gql`
  subscription PetitionBuilderModuleSub($moduleId: String!) {
    moduleBuilderUpdated(id: $moduleId) {
      id
    }
  }
`;

/**
 * __usePetitionBuilderModuleSubSubscription__
 *
 * To run a query within a React component, call `usePetitionBuilderModuleSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePetitionBuilderModuleSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetitionBuilderModuleSubSubscription({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function usePetitionBuilderModuleSubSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types.PetitionBuilderModuleSubSubscription,
    Types.PetitionBuilderModuleSubSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    Types.PetitionBuilderModuleSubSubscription,
    Types.PetitionBuilderModuleSubSubscriptionVariables
  >(PetitionBuilderModuleSubDocument, options);
}
export type PetitionBuilderModuleSubSubscriptionHookResult = ReturnType<
  typeof usePetitionBuilderModuleSubSubscription
>;
export type PetitionBuilderModuleSubSubscriptionResult =
  Apollo.SubscriptionResult<Types.PetitionBuilderModuleSubSubscription>;
export const PetitionBuilderPetitionSubDocument = /*#__PURE__*/ gql`
  subscription PetitionBuilderPetitionSub($petitionId: String!) {
    petitionBuilderPetitionUpdated(id: $petitionId) {
      id
    }
  }
`;

/**
 * __usePetitionBuilderPetitionSubSubscription__
 *
 * To run a query within a React component, call `usePetitionBuilderPetitionSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePetitionBuilderPetitionSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetitionBuilderPetitionSubSubscription({
 *   variables: {
 *      petitionId: // value for 'petitionId'
 *   },
 * });
 */
export function usePetitionBuilderPetitionSubSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types.PetitionBuilderPetitionSubSubscription,
    Types.PetitionBuilderPetitionSubSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    Types.PetitionBuilderPetitionSubSubscription,
    Types.PetitionBuilderPetitionSubSubscriptionVariables
  >(PetitionBuilderPetitionSubDocument, options);
}
export type PetitionBuilderPetitionSubSubscriptionHookResult = ReturnType<
  typeof usePetitionBuilderPetitionSubSubscription
>;
export type PetitionBuilderPetitionSubSubscriptionResult =
  Apollo.SubscriptionResult<Types.PetitionBuilderPetitionSubSubscription>;
export const PetitionBuilderSubexhibitsSubDocument = /*#__PURE__*/ gql`
  subscription PetitionBuilderSubexhibitsSub($parentExhibitId: String!) {
    subexhibitsBuilderUpdated(id: $parentExhibitId) {
      id
    }
  }
`;

/**
 * __usePetitionBuilderSubexhibitsSubSubscription__
 *
 * To run a query within a React component, call `usePetitionBuilderSubexhibitsSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePetitionBuilderSubexhibitsSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetitionBuilderSubexhibitsSubSubscription({
 *   variables: {
 *      parentExhibitId: // value for 'parentExhibitId'
 *   },
 * });
 */
export function usePetitionBuilderSubexhibitsSubSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types.PetitionBuilderSubexhibitsSubSubscription,
    Types.PetitionBuilderSubexhibitsSubSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    Types.PetitionBuilderSubexhibitsSubSubscription,
    Types.PetitionBuilderSubexhibitsSubSubscriptionVariables
  >(PetitionBuilderSubexhibitsSubDocument, options);
}
export type PetitionBuilderSubexhibitsSubSubscriptionHookResult = ReturnType<
  typeof usePetitionBuilderSubexhibitsSubSubscription
>;
export type PetitionBuilderSubexhibitsSubSubscriptionResult =
  Apollo.SubscriptionResult<Types.PetitionBuilderSubexhibitsSubSubscription>;
export const UpdateModuleByIdDocument = /*#__PURE__*/ gql`
  mutation UpdateModuleById($input: UpdateModuleByIdInput!) {
    updateModuleById(input: $input) {
      clientMutationId
      module {
        id
        name
        description
      }
    }
  }
`;
export type UpdateModuleByIdMutationFn = Apollo.MutationFunction<
  Types.UpdateModuleByIdMutation,
  Types.UpdateModuleByIdMutationVariables
>;

/**
 * __useUpdateModuleByIdMutation__
 *
 * To run a mutation, you first call `useUpdateModuleByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModuleByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModuleByIdMutation, { data, loading, error }] = useUpdateModuleByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateModuleByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateModuleByIdMutation,
    Types.UpdateModuleByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateModuleByIdMutation,
    Types.UpdateModuleByIdMutationVariables
  >(UpdateModuleByIdDocument, options);
}
export type UpdateModuleByIdMutationHookResult = ReturnType<
  typeof useUpdateModuleByIdMutation
>;
export type UpdateModuleByIdMutationResult =
  Apollo.MutationResult<Types.UpdateModuleByIdMutation>;
export type UpdateModuleByIdMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateModuleByIdMutation,
  Types.UpdateModuleByIdMutationVariables
>;
export const UpdateExhibitByIdDocument = /*#__PURE__*/ gql`
  mutation UpdateExhibitById($input: UpdateExhibitByIdInput!) {
    updateExhibitById(input: $input) {
      clientMutationId
      exhibit {
        id
        name
        description
        status
        metaData
        metadata
      }
    }
  }
`;
export type UpdateExhibitByIdMutationFn = Apollo.MutationFunction<
  Types.UpdateExhibitByIdMutation,
  Types.UpdateExhibitByIdMutationVariables
>;

/**
 * __useUpdateExhibitByIdMutation__
 *
 * To run a mutation, you first call `useUpdateExhibitByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExhibitByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExhibitByIdMutation, { data, loading, error }] = useUpdateExhibitByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExhibitByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateExhibitByIdMutation,
    Types.UpdateExhibitByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateExhibitByIdMutation,
    Types.UpdateExhibitByIdMutationVariables
  >(UpdateExhibitByIdDocument, options);
}
export type UpdateExhibitByIdMutationHookResult = ReturnType<
  typeof useUpdateExhibitByIdMutation
>;
export type UpdateExhibitByIdMutationResult =
  Apollo.MutationResult<Types.UpdateExhibitByIdMutation>;
export type UpdateExhibitByIdMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateExhibitByIdMutation,
  Types.UpdateExhibitByIdMutationVariables
>;
export const UpdateFileByIdDocument = /*#__PURE__*/ gql`
  mutation UpdateFileById($input: UpdateFileByIdInput!) {
    updateFileById(input: $input) {
      file {
        id
        name
      }
    }
  }
`;
export type UpdateFileByIdMutationFn = Apollo.MutationFunction<
  Types.UpdateFileByIdMutation,
  Types.UpdateFileByIdMutationVariables
>;

/**
 * __useUpdateFileByIdMutation__
 *
 * To run a mutation, you first call `useUpdateFileByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileByIdMutation, { data, loading, error }] = useUpdateFileByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFileByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateFileByIdMutation,
    Types.UpdateFileByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateFileByIdMutation,
    Types.UpdateFileByIdMutationVariables
  >(UpdateFileByIdDocument, options);
}
export type UpdateFileByIdMutationHookResult = ReturnType<
  typeof useUpdateFileByIdMutation
>;
export type UpdateFileByIdMutationResult =
  Apollo.MutationResult<Types.UpdateFileByIdMutation>;
export type UpdateFileByIdMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateFileByIdMutation,
  Types.UpdateFileByIdMutationVariables
>;
export const CreateCaseStrategyDocument = /*#__PURE__*/ gql`
  mutation CreateCaseStrategy($input: CreateCaseStrategyInput!) {
    createCaseStrategy(input: $input) {
      caseStrategy {
        ...CaseStrategyFragment
      }
    }
  }
  ${CaseStrategyFragmentFragmentDoc}
`;
export type CreateCaseStrategyMutationFn = Apollo.MutationFunction<
  Types.CreateCaseStrategyMutation,
  Types.CreateCaseStrategyMutationVariables
>;

/**
 * __useCreateCaseStrategyMutation__
 *
 * To run a mutation, you first call `useCreateCaseStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseStrategyMutation, { data, loading, error }] = useCreateCaseStrategyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCaseStrategyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateCaseStrategyMutation,
    Types.CreateCaseStrategyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateCaseStrategyMutation,
    Types.CreateCaseStrategyMutationVariables
  >(CreateCaseStrategyDocument, options);
}
export type CreateCaseStrategyMutationHookResult = ReturnType<
  typeof useCreateCaseStrategyMutation
>;
export type CreateCaseStrategyMutationResult =
  Apollo.MutationResult<Types.CreateCaseStrategyMutation>;
export type CreateCaseStrategyMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateCaseStrategyMutation,
  Types.CreateCaseStrategyMutationVariables
>;
export const UpdateCaseStrategyByIdDocument = /*#__PURE__*/ gql`
  mutation UpdateCaseStrategyById($input: UpdateCaseStrategyByIdInput!) {
    updateCaseStrategyById(input: $input) {
      caseStrategy {
        ...CaseStrategyFragment
      }
    }
  }
  ${CaseStrategyFragmentFragmentDoc}
`;
export type UpdateCaseStrategyByIdMutationFn = Apollo.MutationFunction<
  Types.UpdateCaseStrategyByIdMutation,
  Types.UpdateCaseStrategyByIdMutationVariables
>;

/**
 * __useUpdateCaseStrategyByIdMutation__
 *
 * To run a mutation, you first call `useUpdateCaseStrategyByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseStrategyByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseStrategyByIdMutation, { data, loading, error }] = useUpdateCaseStrategyByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCaseStrategyByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateCaseStrategyByIdMutation,
    Types.UpdateCaseStrategyByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateCaseStrategyByIdMutation,
    Types.UpdateCaseStrategyByIdMutationVariables
  >(UpdateCaseStrategyByIdDocument, options);
}
export type UpdateCaseStrategyByIdMutationHookResult = ReturnType<
  typeof useUpdateCaseStrategyByIdMutation
>;
export type UpdateCaseStrategyByIdMutationResult =
  Apollo.MutationResult<Types.UpdateCaseStrategyByIdMutation>;
export type UpdateCaseStrategyByIdMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateCaseStrategyByIdMutation,
  Types.UpdateCaseStrategyByIdMutationVariables
>;
export const CaseStrategyByIdDocument = /*#__PURE__*/ gql`
  query CaseStrategyById($id: Int!) {
    caseStrategyById(id: $id) {
      id
      nodeId
      label
      strategy
    }
  }
`;

/**
 * __useCaseStrategyByIdQuery__
 *
 * To run a query within a React component, call `useCaseStrategyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseStrategyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseStrategyByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCaseStrategyByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.CaseStrategyByIdQuery,
    Types.CaseStrategyByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.CaseStrategyByIdQuery,
    Types.CaseStrategyByIdQueryVariables
  >(CaseStrategyByIdDocument, options);
}
export function useCaseStrategyByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CaseStrategyByIdQuery,
    Types.CaseStrategyByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.CaseStrategyByIdQuery,
    Types.CaseStrategyByIdQueryVariables
  >(CaseStrategyByIdDocument, options);
}
export type CaseStrategyByIdQueryHookResult = ReturnType<
  typeof useCaseStrategyByIdQuery
>;
export type CaseStrategyByIdLazyQueryHookResult = ReturnType<
  typeof useCaseStrategyByIdLazyQuery
>;
export type CaseStrategyByIdQueryResult = Apollo.QueryResult<
  Types.CaseStrategyByIdQuery,
  Types.CaseStrategyByIdQueryVariables
>;
export const PetitionNoteLogDocument = /*#__PURE__*/ gql`
  query PetitionNoteLog($petitionByIdId: BigInt!, $orderBy: [NotesOrderBy!]) {
    petitionById(id: $petitionByIdId) {
      notesByPetitionId(orderBy: $orderBy) {
        nodes {
          id
          nodeId
          userByUserId {
            fullName
          }
          userBySenderId {
            fullName
          }
          createdAt
          content
        }
      }
    }
  }
`;

/**
 * __usePetitionNoteLogQuery__
 *
 * To run a query within a React component, call `usePetitionNoteLogQuery` and pass it any options that fit your needs.
 * When your component renders, `usePetitionNoteLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetitionNoteLogQuery({
 *   variables: {
 *      petitionByIdId: // value for 'petitionByIdId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePetitionNoteLogQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PetitionNoteLogQuery,
    Types.PetitionNoteLogQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PetitionNoteLogQuery,
    Types.PetitionNoteLogQueryVariables
  >(PetitionNoteLogDocument, options);
}
export function usePetitionNoteLogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PetitionNoteLogQuery,
    Types.PetitionNoteLogQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PetitionNoteLogQuery,
    Types.PetitionNoteLogQueryVariables
  >(PetitionNoteLogDocument, options);
}
export type PetitionNoteLogQueryHookResult = ReturnType<
  typeof usePetitionNoteLogQuery
>;
export type PetitionNoteLogLazyQueryHookResult = ReturnType<
  typeof usePetitionNoteLogLazyQuery
>;
export type PetitionNoteLogQueryResult = Apollo.QueryResult<
  Types.PetitionNoteLogQuery,
  Types.PetitionNoteLogQueryVariables
>;
export const CreateNoteDocument = /*#__PURE__*/ gql`
  mutation CreateNote($input: CreateNoteInput!) {
    createNote(input: $input) {
      note {
        id
        userByUserId {
          fullName
        }
        userBySenderId {
          fullName
        }
        createdAt
        content
      }
    }
  }
`;
export type CreateNoteMutationFn = Apollo.MutationFunction<
  Types.CreateNoteMutation,
  Types.CreateNoteMutationVariables
>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateNoteMutation,
    Types.CreateNoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateNoteMutation,
    Types.CreateNoteMutationVariables
  >(CreateNoteDocument, options);
}
export type CreateNoteMutationHookResult = ReturnType<
  typeof useCreateNoteMutation
>;
export type CreateNoteMutationResult =
  Apollo.MutationResult<Types.CreateNoteMutation>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateNoteMutation,
  Types.CreateNoteMutationVariables
>;
export const UpdateNoteDocument = /*#__PURE__*/ gql`
  mutation UpdateNote($input: UpdateNoteInput!) {
    updateNote(input: $input) {
      note {
        id
        nodeId
        userByUserId {
          fullName
        }
        userBySenderId {
          fullName
        }
        createdAt
        content
      }
    }
  }
`;
export type UpdateNoteMutationFn = Apollo.MutationFunction<
  Types.UpdateNoteMutation,
  Types.UpdateNoteMutationVariables
>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateNoteMutation,
    Types.UpdateNoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateNoteMutation,
    Types.UpdateNoteMutationVariables
  >(UpdateNoteDocument, options);
}
export type UpdateNoteMutationHookResult = ReturnType<
  typeof useUpdateNoteMutation
>;
export type UpdateNoteMutationResult =
  Apollo.MutationResult<Types.UpdateNoteMutation>;
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateNoteMutation,
  Types.UpdateNoteMutationVariables
>;
export const DeleteNoteDocument = /*#__PURE__*/ gql`
  mutation DeleteNote($input: DeleteNoteInput!) {
    deleteNote(input: $input) {
      deletedNoteId
    }
  }
`;
export type DeleteNoteMutationFn = Apollo.MutationFunction<
  Types.DeleteNoteMutation,
  Types.DeleteNoteMutationVariables
>;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteNoteMutation,
    Types.DeleteNoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DeleteNoteMutation,
    Types.DeleteNoteMutationVariables
  >(DeleteNoteDocument, options);
}
export type DeleteNoteMutationHookResult = ReturnType<
  typeof useDeleteNoteMutation
>;
export type DeleteNoteMutationResult =
  Apollo.MutationResult<Types.DeleteNoteMutation>;
export type DeleteNoteMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteNoteMutation,
  Types.DeleteNoteMutationVariables
>;
export const AllPlymouthDocumentsDocument = /*#__PURE__*/ gql`
  query AllPlymouthDocuments {
    allPlymouthDocuments {
      nodes {
        nodeId
        fileId
        fileByFileId {
          id
          name
          mimeType
          ownerId
        }
      }
    }
  }
`;

/**
 * __useAllPlymouthDocumentsQuery__
 *
 * To run a query within a React component, call `useAllPlymouthDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPlymouthDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPlymouthDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPlymouthDocumentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AllPlymouthDocumentsQuery,
    Types.AllPlymouthDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllPlymouthDocumentsQuery,
    Types.AllPlymouthDocumentsQueryVariables
  >(AllPlymouthDocumentsDocument, options);
}
export function useAllPlymouthDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllPlymouthDocumentsQuery,
    Types.AllPlymouthDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllPlymouthDocumentsQuery,
    Types.AllPlymouthDocumentsQueryVariables
  >(AllPlymouthDocumentsDocument, options);
}
export type AllPlymouthDocumentsQueryHookResult = ReturnType<
  typeof useAllPlymouthDocumentsQuery
>;
export type AllPlymouthDocumentsLazyQueryHookResult = ReturnType<
  typeof useAllPlymouthDocumentsLazyQuery
>;
export type AllPlymouthDocumentsQueryResult = Apollo.QueryResult<
  Types.AllPlymouthDocumentsQuery,
  Types.AllPlymouthDocumentsQueryVariables
>;
export const AllPlymouthDocumentsByFileIdDocument = /*#__PURE__*/ gql`
  query AllPlymouthDocumentsByFileId($fileId: BigInt!) {
    allPlymouthDocuments(condition: { fileId: $fileId }) {
      nodes {
        nodeId
        fileId
        fileByFileId {
          id
          name
          mimeType
          ownerId
        }
      }
    }
  }
`;

/**
 * __useAllPlymouthDocumentsByFileIdQuery__
 *
 * To run a query within a React component, call `useAllPlymouthDocumentsByFileIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPlymouthDocumentsByFileIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPlymouthDocumentsByFileIdQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useAllPlymouthDocumentsByFileIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.AllPlymouthDocumentsByFileIdQuery,
    Types.AllPlymouthDocumentsByFileIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllPlymouthDocumentsByFileIdQuery,
    Types.AllPlymouthDocumentsByFileIdQueryVariables
  >(AllPlymouthDocumentsByFileIdDocument, options);
}
export function useAllPlymouthDocumentsByFileIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllPlymouthDocumentsByFileIdQuery,
    Types.AllPlymouthDocumentsByFileIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllPlymouthDocumentsByFileIdQuery,
    Types.AllPlymouthDocumentsByFileIdQueryVariables
  >(AllPlymouthDocumentsByFileIdDocument, options);
}
export type AllPlymouthDocumentsByFileIdQueryHookResult = ReturnType<
  typeof useAllPlymouthDocumentsByFileIdQuery
>;
export type AllPlymouthDocumentsByFileIdLazyQueryHookResult = ReturnType<
  typeof useAllPlymouthDocumentsByFileIdLazyQuery
>;
export type AllPlymouthDocumentsByFileIdQueryResult = Apollo.QueryResult<
  Types.AllPlymouthDocumentsByFileIdQuery,
  Types.AllPlymouthDocumentsByFileIdQueryVariables
>;
export const AllUserDocumentsByUserIdDocument = /*#__PURE__*/ gql`
  query AllUserDocumentsByUserId($userId: BigInt!) {
    allUserDocuments(condition: { userId: $userId }) {
      nodes {
        nodeId
        fileId
        documentType
        fileByFileId {
          id
          name
          mimeType
          ownerId
        }
      }
    }
  }
`;

/**
 * __useAllUserDocumentsByUserIdQuery__
 *
 * To run a query within a React component, call `useAllUserDocumentsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserDocumentsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUserDocumentsByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAllUserDocumentsByUserIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.AllUserDocumentsByUserIdQuery,
    Types.AllUserDocumentsByUserIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllUserDocumentsByUserIdQuery,
    Types.AllUserDocumentsByUserIdQueryVariables
  >(AllUserDocumentsByUserIdDocument, options);
}
export function useAllUserDocumentsByUserIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllUserDocumentsByUserIdQuery,
    Types.AllUserDocumentsByUserIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllUserDocumentsByUserIdQuery,
    Types.AllUserDocumentsByUserIdQueryVariables
  >(AllUserDocumentsByUserIdDocument, options);
}
export type AllUserDocumentsByUserIdQueryHookResult = ReturnType<
  typeof useAllUserDocumentsByUserIdQuery
>;
export type AllUserDocumentsByUserIdLazyQueryHookResult = ReturnType<
  typeof useAllUserDocumentsByUserIdLazyQuery
>;
export type AllUserDocumentsByUserIdQueryResult = Apollo.QueryResult<
  Types.AllUserDocumentsByUserIdQuery,
  Types.AllUserDocumentsByUserIdQueryVariables
>;
export const AllUserFilesByUserIdWithTypeDocument = /*#__PURE__*/ gql`
  query AllUserFilesByUserIdWithType($userId: BigInt!) {
    allFiles(condition: { ownerId: $userId }, orderBy: [CREATED_AT_DESC]) {
      nodes {
        id
        name
        mimeType
        userDocumentsByFileId {
          nodes {
            nodeId
            documentType
            fileId
          }
        }
        immigrationDocumentsByFileId {
          nodes {
            type
            nodeId
            fileId
          }
        }
        exhibitFilesByFileId {
          nodes {
            fileId
            nodeId
            exhibitId
            exhibitByExhibitId {
              exhibitType
              moduleByModuleId {
                type
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useAllUserFilesByUserIdWithTypeQuery__
 *
 * To run a query within a React component, call `useAllUserFilesByUserIdWithTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserFilesByUserIdWithTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUserFilesByUserIdWithTypeQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAllUserFilesByUserIdWithTypeQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.AllUserFilesByUserIdWithTypeQuery,
    Types.AllUserFilesByUserIdWithTypeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllUserFilesByUserIdWithTypeQuery,
    Types.AllUserFilesByUserIdWithTypeQueryVariables
  >(AllUserFilesByUserIdWithTypeDocument, options);
}
export function useAllUserFilesByUserIdWithTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllUserFilesByUserIdWithTypeQuery,
    Types.AllUserFilesByUserIdWithTypeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllUserFilesByUserIdWithTypeQuery,
    Types.AllUserFilesByUserIdWithTypeQueryVariables
  >(AllUserFilesByUserIdWithTypeDocument, options);
}
export type AllUserFilesByUserIdWithTypeQueryHookResult = ReturnType<
  typeof useAllUserFilesByUserIdWithTypeQuery
>;
export type AllUserFilesByUserIdWithTypeLazyQueryHookResult = ReturnType<
  typeof useAllUserFilesByUserIdWithTypeLazyQuery
>;
export type AllUserFilesByUserIdWithTypeQueryResult = Apollo.QueryResult<
  Types.AllUserFilesByUserIdWithTypeQuery,
  Types.AllUserFilesByUserIdWithTypeQueryVariables
>;
export const DeletePlymouthDocumentDocument = /*#__PURE__*/ gql`
  mutation DeletePlymouthDocument($input: DeletePlymouthDocumentInput!) {
    deletePlymouthDocument(input: $input) {
      clientMutationId
      deletedPlymouthDocumentId
    }
  }
`;
export type DeletePlymouthDocumentMutationFn = Apollo.MutationFunction<
  Types.DeletePlymouthDocumentMutation,
  Types.DeletePlymouthDocumentMutationVariables
>;

/**
 * __useDeletePlymouthDocumentMutation__
 *
 * To run a mutation, you first call `useDeletePlymouthDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlymouthDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlymouthDocumentMutation, { data, loading, error }] = useDeletePlymouthDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePlymouthDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeletePlymouthDocumentMutation,
    Types.DeletePlymouthDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DeletePlymouthDocumentMutation,
    Types.DeletePlymouthDocumentMutationVariables
  >(DeletePlymouthDocumentDocument, options);
}
export type DeletePlymouthDocumentMutationHookResult = ReturnType<
  typeof useDeletePlymouthDocumentMutation
>;
export type DeletePlymouthDocumentMutationResult =
  Apollo.MutationResult<Types.DeletePlymouthDocumentMutation>;
export type DeletePlymouthDocumentMutationOptions = Apollo.BaseMutationOptions<
  Types.DeletePlymouthDocumentMutation,
  Types.DeletePlymouthDocumentMutationVariables
>;
export const OnboardingByPetitionIdDocument = /*#__PURE__*/ gql`
  query OnboardingByPetitionId($petitionId: BigInt!) {
    allOnboardings(
      condition: { petitionId: $petitionId }
      orderBy: CREATED_AT_DESC
    ) {
      nodes {
        nodeId
        id
        petitionId
        modules
        status
        version
      }
    }
  }
`;

/**
 * __useOnboardingByPetitionIdQuery__
 *
 * To run a query within a React component, call `useOnboardingByPetitionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingByPetitionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingByPetitionIdQuery({
 *   variables: {
 *      petitionId: // value for 'petitionId'
 *   },
 * });
 */
export function useOnboardingByPetitionIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.OnboardingByPetitionIdQuery,
    Types.OnboardingByPetitionIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.OnboardingByPetitionIdQuery,
    Types.OnboardingByPetitionIdQueryVariables
  >(OnboardingByPetitionIdDocument, options);
}
export function useOnboardingByPetitionIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.OnboardingByPetitionIdQuery,
    Types.OnboardingByPetitionIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.OnboardingByPetitionIdQuery,
    Types.OnboardingByPetitionIdQueryVariables
  >(OnboardingByPetitionIdDocument, options);
}
export type OnboardingByPetitionIdQueryHookResult = ReturnType<
  typeof useOnboardingByPetitionIdQuery
>;
export type OnboardingByPetitionIdLazyQueryHookResult = ReturnType<
  typeof useOnboardingByPetitionIdLazyQuery
>;
export type OnboardingByPetitionIdQueryResult = Apollo.QueryResult<
  Types.OnboardingByPetitionIdQuery,
  Types.OnboardingByPetitionIdQueryVariables
>;
export const PendingPetitionTasksDocument = /*#__PURE__*/ gql`
  query PendingPetitionTasks($petitionById: BigInt!) {
    petitionById(id: $petitionById) {
      pendingPetitionTasksByPetitionId {
        nodes {
          id
          nodeId
          userByCreatedById {
            fullName
          }
          userByCompletedById {
            fullName
          }
          completedAt
          createdAt
          content
          link
          exhibitByExhibitId {
            id
            name
            exhibitType
            moduleByModuleId {
              type
            }
          }
        }
      }
    }
  }
`;

/**
 * __usePendingPetitionTasksQuery__
 *
 * To run a query within a React component, call `usePendingPetitionTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingPetitionTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingPetitionTasksQuery({
 *   variables: {
 *      petitionById: // value for 'petitionById'
 *   },
 * });
 */
export function usePendingPetitionTasksQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PendingPetitionTasksQuery,
    Types.PendingPetitionTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PendingPetitionTasksQuery,
    Types.PendingPetitionTasksQueryVariables
  >(PendingPetitionTasksDocument, options);
}
export function usePendingPetitionTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PendingPetitionTasksQuery,
    Types.PendingPetitionTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PendingPetitionTasksQuery,
    Types.PendingPetitionTasksQueryVariables
  >(PendingPetitionTasksDocument, options);
}
export type PendingPetitionTasksQueryHookResult = ReturnType<
  typeof usePendingPetitionTasksQuery
>;
export type PendingPetitionTasksLazyQueryHookResult = ReturnType<
  typeof usePendingPetitionTasksLazyQuery
>;
export type PendingPetitionTasksQueryResult = Apollo.QueryResult<
  Types.PendingPetitionTasksQuery,
  Types.PendingPetitionTasksQueryVariables
>;
export const CreatePendingPetitionTaskDocument = /*#__PURE__*/ gql`
  mutation CreatePendingPetitionTask($input: CreatePendingPetitionTaskInput!) {
    createPendingPetitionTask(input: $input) {
      pendingPetitionTask {
        id
        content
        link
        createdAt
        completedAt
        createdById
        completedById
      }
      userByCreatedById {
        fullName
      }
      userByCompletedById {
        fullName
      }
    }
  }
`;
export type CreatePendingPetitionTaskMutationFn = Apollo.MutationFunction<
  Types.CreatePendingPetitionTaskMutation,
  Types.CreatePendingPetitionTaskMutationVariables
>;

/**
 * __useCreatePendingPetitionTaskMutation__
 *
 * To run a mutation, you first call `useCreatePendingPetitionTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePendingPetitionTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPendingPetitionTaskMutation, { data, loading, error }] = useCreatePendingPetitionTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePendingPetitionTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreatePendingPetitionTaskMutation,
    Types.CreatePendingPetitionTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreatePendingPetitionTaskMutation,
    Types.CreatePendingPetitionTaskMutationVariables
  >(CreatePendingPetitionTaskDocument, options);
}
export type CreatePendingPetitionTaskMutationHookResult = ReturnType<
  typeof useCreatePendingPetitionTaskMutation
>;
export type CreatePendingPetitionTaskMutationResult =
  Apollo.MutationResult<Types.CreatePendingPetitionTaskMutation>;
export type CreatePendingPetitionTaskMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreatePendingPetitionTaskMutation,
    Types.CreatePendingPetitionTaskMutationVariables
  >;
export const DeletePendingPetitionTaskDocument = /*#__PURE__*/ gql`
  mutation DeletePendingPetitionTask($input: DeletePendingPetitionTaskInput!) {
    deletePendingPetitionTask(input: $input) {
      deletedPendingPetitionTaskId
    }
  }
`;
export type DeletePendingPetitionTaskMutationFn = Apollo.MutationFunction<
  Types.DeletePendingPetitionTaskMutation,
  Types.DeletePendingPetitionTaskMutationVariables
>;

/**
 * __useDeletePendingPetitionTaskMutation__
 *
 * To run a mutation, you first call `useDeletePendingPetitionTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePendingPetitionTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePendingPetitionTaskMutation, { data, loading, error }] = useDeletePendingPetitionTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePendingPetitionTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeletePendingPetitionTaskMutation,
    Types.DeletePendingPetitionTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DeletePendingPetitionTaskMutation,
    Types.DeletePendingPetitionTaskMutationVariables
  >(DeletePendingPetitionTaskDocument, options);
}
export type DeletePendingPetitionTaskMutationHookResult = ReturnType<
  typeof useDeletePendingPetitionTaskMutation
>;
export type DeletePendingPetitionTaskMutationResult =
  Apollo.MutationResult<Types.DeletePendingPetitionTaskMutation>;
export type DeletePendingPetitionTaskMutationOptions =
  Apollo.BaseMutationOptions<
    Types.DeletePendingPetitionTaskMutation,
    Types.DeletePendingPetitionTaskMutationVariables
  >;
export const UpdatePendingPetitionTaskDocument = /*#__PURE__*/ gql`
  mutation UpdatePendingPetitionTask($input: UpdatePendingPetitionTaskInput!) {
    updatePendingPetitionTask(input: $input) {
      pendingPetitionTask {
        id
        content
        link
        createdAt
        completedAt
        createdById
        completedById
      }
      userByCreatedById {
        fullName
      }
      userByCompletedById {
        fullName
      }
    }
  }
`;
export type UpdatePendingPetitionTaskMutationFn = Apollo.MutationFunction<
  Types.UpdatePendingPetitionTaskMutation,
  Types.UpdatePendingPetitionTaskMutationVariables
>;

/**
 * __useUpdatePendingPetitionTaskMutation__
 *
 * To run a mutation, you first call `useUpdatePendingPetitionTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePendingPetitionTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePendingPetitionTaskMutation, { data, loading, error }] = useUpdatePendingPetitionTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePendingPetitionTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdatePendingPetitionTaskMutation,
    Types.UpdatePendingPetitionTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdatePendingPetitionTaskMutation,
    Types.UpdatePendingPetitionTaskMutationVariables
  >(UpdatePendingPetitionTaskDocument, options);
}
export type UpdatePendingPetitionTaskMutationHookResult = ReturnType<
  typeof useUpdatePendingPetitionTaskMutation
>;
export type UpdatePendingPetitionTaskMutationResult =
  Apollo.MutationResult<Types.UpdatePendingPetitionTaskMutation>;
export type UpdatePendingPetitionTaskMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdatePendingPetitionTaskMutation,
    Types.UpdatePendingPetitionTaskMutationVariables
  >;
export const AllChecklistSectionsDocument = /*#__PURE__*/ gql`
  query AllChecklistSections {
    allChecklistSections {
      nodes {
        id
        name
        position
      }
    }
    allChecklistTasks {
      nodes {
        code
        id
        label
        position
        sectionId
      }
    }
  }
`;

/**
 * __useAllChecklistSectionsQuery__
 *
 * To run a query within a React component, call `useAllChecklistSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllChecklistSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllChecklistSectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllChecklistSectionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AllChecklistSectionsQuery,
    Types.AllChecklistSectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllChecklistSectionsQuery,
    Types.AllChecklistSectionsQueryVariables
  >(AllChecklistSectionsDocument, options);
}
export function useAllChecklistSectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllChecklistSectionsQuery,
    Types.AllChecklistSectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllChecklistSectionsQuery,
    Types.AllChecklistSectionsQueryVariables
  >(AllChecklistSectionsDocument, options);
}
export type AllChecklistSectionsQueryHookResult = ReturnType<
  typeof useAllChecklistSectionsQuery
>;
export type AllChecklistSectionsLazyQueryHookResult = ReturnType<
  typeof useAllChecklistSectionsLazyQuery
>;
export type AllChecklistSectionsQueryResult = Apollo.QueryResult<
  Types.AllChecklistSectionsQuery,
  Types.AllChecklistSectionsQueryVariables
>;
export const PetitionChecklistItemByIdDocument = /*#__PURE__*/ gql`
  query PetitionChecklistItemById($id: BigInt!) {
    petitionChecklistItemById(id: $id) {
      id
      completedAt
      completedById
      userByCompletedById {
        id
        fullName
      }
      note
      taskId
    }
  }
`;

/**
 * __usePetitionChecklistItemByIdQuery__
 *
 * To run a query within a React component, call `usePetitionChecklistItemByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePetitionChecklistItemByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetitionChecklistItemByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePetitionChecklistItemByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PetitionChecklistItemByIdQuery,
    Types.PetitionChecklistItemByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PetitionChecklistItemByIdQuery,
    Types.PetitionChecklistItemByIdQueryVariables
  >(PetitionChecklistItemByIdDocument, options);
}
export function usePetitionChecklistItemByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PetitionChecklistItemByIdQuery,
    Types.PetitionChecklistItemByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PetitionChecklistItemByIdQuery,
    Types.PetitionChecklistItemByIdQueryVariables
  >(PetitionChecklistItemByIdDocument, options);
}
export type PetitionChecklistItemByIdQueryHookResult = ReturnType<
  typeof usePetitionChecklistItemByIdQuery
>;
export type PetitionChecklistItemByIdLazyQueryHookResult = ReturnType<
  typeof usePetitionChecklistItemByIdLazyQuery
>;
export type PetitionChecklistItemByIdQueryResult = Apollo.QueryResult<
  Types.PetitionChecklistItemByIdQuery,
  Types.PetitionChecklistItemByIdQueryVariables
>;
export const CreatePetitionChecklistItemDocument = /*#__PURE__*/ gql`
  mutation CreatePetitionChecklistItem(
    $input: CreatePetitionChecklistItemInput!
  ) {
    createPetitionChecklistItem(input: $input) {
      petitionChecklistItem {
        completedAt
        completedById
        note
        taskId
      }
    }
  }
`;
export type CreatePetitionChecklistItemMutationFn = Apollo.MutationFunction<
  Types.CreatePetitionChecklistItemMutation,
  Types.CreatePetitionChecklistItemMutationVariables
>;

/**
 * __useCreatePetitionChecklistItemMutation__
 *
 * To run a mutation, you first call `useCreatePetitionChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePetitionChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPetitionChecklistItemMutation, { data, loading, error }] = useCreatePetitionChecklistItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePetitionChecklistItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreatePetitionChecklistItemMutation,
    Types.CreatePetitionChecklistItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreatePetitionChecklistItemMutation,
    Types.CreatePetitionChecklistItemMutationVariables
  >(CreatePetitionChecklistItemDocument, options);
}
export type CreatePetitionChecklistItemMutationHookResult = ReturnType<
  typeof useCreatePetitionChecklistItemMutation
>;
export type CreatePetitionChecklistItemMutationResult =
  Apollo.MutationResult<Types.CreatePetitionChecklistItemMutation>;
export type CreatePetitionChecklistItemMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreatePetitionChecklistItemMutation,
    Types.CreatePetitionChecklistItemMutationVariables
  >;
export const DeletePetitionChecklistItemByIdDocument = /*#__PURE__*/ gql`
  mutation DeletePetitionChecklistItemById(
    $input: DeletePetitionChecklistItemByIdInput!
  ) {
    deletePetitionChecklistItemById(input: $input) {
      deletedPetitionChecklistItemId
    }
  }
`;
export type DeletePetitionChecklistItemByIdMutationFn = Apollo.MutationFunction<
  Types.DeletePetitionChecklistItemByIdMutation,
  Types.DeletePetitionChecklistItemByIdMutationVariables
>;

/**
 * __useDeletePetitionChecklistItemByIdMutation__
 *
 * To run a mutation, you first call `useDeletePetitionChecklistItemByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePetitionChecklistItemByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePetitionChecklistItemByIdMutation, { data, loading, error }] = useDeletePetitionChecklistItemByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePetitionChecklistItemByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeletePetitionChecklistItemByIdMutation,
    Types.DeletePetitionChecklistItemByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DeletePetitionChecklistItemByIdMutation,
    Types.DeletePetitionChecklistItemByIdMutationVariables
  >(DeletePetitionChecklistItemByIdDocument, options);
}
export type DeletePetitionChecklistItemByIdMutationHookResult = ReturnType<
  typeof useDeletePetitionChecklistItemByIdMutation
>;
export type DeletePetitionChecklistItemByIdMutationResult =
  Apollo.MutationResult<Types.DeletePetitionChecklistItemByIdMutation>;
export type DeletePetitionChecklistItemByIdMutationOptions =
  Apollo.BaseMutationOptions<
    Types.DeletePetitionChecklistItemByIdMutation,
    Types.DeletePetitionChecklistItemByIdMutationVariables
  >;
export const UpdatePetitionChecklistItemByIdDocument = /*#__PURE__*/ gql`
  mutation UpdatePetitionChecklistItemById(
    $input: UpdatePetitionChecklistItemByIdInput!
  ) {
    updatePetitionChecklistItemById(input: $input) {
      petitionChecklistItem {
        id
        completedAt
        completedById
        note
        userByCompletedById {
          id
          fullName
        }
      }
    }
  }
`;
export type UpdatePetitionChecklistItemByIdMutationFn = Apollo.MutationFunction<
  Types.UpdatePetitionChecklistItemByIdMutation,
  Types.UpdatePetitionChecklistItemByIdMutationVariables
>;

/**
 * __useUpdatePetitionChecklistItemByIdMutation__
 *
 * To run a mutation, you first call `useUpdatePetitionChecklistItemByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePetitionChecklistItemByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePetitionChecklistItemByIdMutation, { data, loading, error }] = useUpdatePetitionChecklistItemByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePetitionChecklistItemByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdatePetitionChecklistItemByIdMutation,
    Types.UpdatePetitionChecklistItemByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdatePetitionChecklistItemByIdMutation,
    Types.UpdatePetitionChecklistItemByIdMutationVariables
  >(UpdatePetitionChecklistItemByIdDocument, options);
}
export type UpdatePetitionChecklistItemByIdMutationHookResult = ReturnType<
  typeof useUpdatePetitionChecklistItemByIdMutation
>;
export type UpdatePetitionChecklistItemByIdMutationResult =
  Apollo.MutationResult<Types.UpdatePetitionChecklistItemByIdMutation>;
export type UpdatePetitionChecklistItemByIdMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdatePetitionChecklistItemByIdMutation,
    Types.UpdatePetitionChecklistItemByIdMutationVariables
  >;
export const PetitionChecklistItemsWithModulesDocument = /*#__PURE__*/ gql`
  query PetitionChecklistItemsWithModules($petitionId: BigInt!) {
    allPetitionChecklistItems(condition: { petitionId: $petitionId }) {
      nodes {
        id
        petitionId
        moduleId
        moduleByModuleId {
          id
          name
          description
        }
        taskId
        completedAt
        completedById
        userByCompletedById {
          id
          fullName
        }
        note
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * __usePetitionChecklistItemsWithModulesQuery__
 *
 * To run a query within a React component, call `usePetitionChecklistItemsWithModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePetitionChecklistItemsWithModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetitionChecklistItemsWithModulesQuery({
 *   variables: {
 *      petitionId: // value for 'petitionId'
 *   },
 * });
 */
export function usePetitionChecklistItemsWithModulesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PetitionChecklistItemsWithModulesQuery,
    Types.PetitionChecklistItemsWithModulesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PetitionChecklistItemsWithModulesQuery,
    Types.PetitionChecklistItemsWithModulesQueryVariables
  >(PetitionChecklistItemsWithModulesDocument, options);
}
export function usePetitionChecklistItemsWithModulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PetitionChecklistItemsWithModulesQuery,
    Types.PetitionChecklistItemsWithModulesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PetitionChecklistItemsWithModulesQuery,
    Types.PetitionChecklistItemsWithModulesQueryVariables
  >(PetitionChecklistItemsWithModulesDocument, options);
}
export type PetitionChecklistItemsWithModulesQueryHookResult = ReturnType<
  typeof usePetitionChecklistItemsWithModulesQuery
>;
export type PetitionChecklistItemsWithModulesLazyQueryHookResult = ReturnType<
  typeof usePetitionChecklistItemsWithModulesLazyQuery
>;
export type PetitionChecklistItemsWithModulesQueryResult = Apollo.QueryResult<
  Types.PetitionChecklistItemsWithModulesQuery,
  Types.PetitionChecklistItemsWithModulesQueryVariables
>;
export const AllCompaniesDocument = /*#__PURE__*/ gql`
  query AllCompanies {
    allCompanies {
      nodes {
        id
        dbaName
      }
    }
  }
`;

/**
 * __useAllCompaniesQuery__
 *
 * To run a query within a React component, call `useAllCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCompaniesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AllCompaniesQuery,
    Types.AllCompaniesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllCompaniesQuery,
    Types.AllCompaniesQueryVariables
  >(AllCompaniesDocument, options);
}
export function useAllCompaniesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllCompaniesQuery,
    Types.AllCompaniesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllCompaniesQuery,
    Types.AllCompaniesQueryVariables
  >(AllCompaniesDocument, options);
}
export type AllCompaniesQueryHookResult = ReturnType<
  typeof useAllCompaniesQuery
>;
export type AllCompaniesLazyQueryHookResult = ReturnType<
  typeof useAllCompaniesLazyQuery
>;
export type AllCompaniesQueryResult = Apollo.QueryResult<
  Types.AllCompaniesQuery,
  Types.AllCompaniesQueryVariables
>;
export const FilesByUserIdDocument = /*#__PURE__*/ gql`
  query FilesByUserId($id: BigInt!) {
    allFiles(condition: { ownerId: $id }) {
      nodes {
        id
        name
        createdAt
      }
    }
  }
`;

/**
 * __useFilesByUserIdQuery__
 *
 * To run a query within a React component, call `useFilesByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilesByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilesByUserIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFilesByUserIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.FilesByUserIdQuery,
    Types.FilesByUserIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.FilesByUserIdQuery,
    Types.FilesByUserIdQueryVariables
  >(FilesByUserIdDocument, options);
}
export function useFilesByUserIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FilesByUserIdQuery,
    Types.FilesByUserIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.FilesByUserIdQuery,
    Types.FilesByUserIdQueryVariables
  >(FilesByUserIdDocument, options);
}
export type FilesByUserIdQueryHookResult = ReturnType<
  typeof useFilesByUserIdQuery
>;
export type FilesByUserIdLazyQueryHookResult = ReturnType<
  typeof useFilesByUserIdLazyQuery
>;
export type FilesByUserIdQueryResult = Apollo.QueryResult<
  Types.FilesByUserIdQuery,
  Types.FilesByUserIdQueryVariables
>;
export const ExhibitTypesDocument = /*#__PURE__*/ gql`
  query ExhibitTypes {
    allExhibitTypes {
      nodes {
        id
        name
      }
    }
  }
`;

/**
 * __useExhibitTypesQuery__
 *
 * To run a query within a React component, call `useExhibitTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExhibitTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExhibitTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useExhibitTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.ExhibitTypesQuery,
    Types.ExhibitTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ExhibitTypesQuery,
    Types.ExhibitTypesQueryVariables
  >(ExhibitTypesDocument, options);
}
export function useExhibitTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ExhibitTypesQuery,
    Types.ExhibitTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ExhibitTypesQuery,
    Types.ExhibitTypesQueryVariables
  >(ExhibitTypesDocument, options);
}
export type ExhibitTypesQueryHookResult = ReturnType<
  typeof useExhibitTypesQuery
>;
export type ExhibitTypesLazyQueryHookResult = ReturnType<
  typeof useExhibitTypesLazyQuery
>;
export type ExhibitTypesQueryResult = Apollo.QueryResult<
  Types.ExhibitTypesQuery,
  Types.ExhibitTypesQueryVariables
>;
export const PetitionUpdatedDocument = /*#__PURE__*/ gql`
  subscription PetitionUpdated($wsId: String!) {
    petitionUpdated(wsId: $wsId) {
      id
    }
  }
`;

/**
 * __usePetitionUpdatedSubscription__
 *
 * To run a query within a React component, call `usePetitionUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePetitionUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetitionUpdatedSubscription({
 *   variables: {
 *      wsId: // value for 'wsId'
 *   },
 * });
 */
export function usePetitionUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types.PetitionUpdatedSubscription,
    Types.PetitionUpdatedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    Types.PetitionUpdatedSubscription,
    Types.PetitionUpdatedSubscriptionVariables
  >(PetitionUpdatedDocument, options);
}
export type PetitionUpdatedSubscriptionHookResult = ReturnType<
  typeof usePetitionUpdatedSubscription
>;
export type PetitionUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<Types.PetitionUpdatedSubscription>;
export const UpdateImmigrationDocOrderDocument = /*#__PURE__*/ gql`
  mutation UpdateImmigrationDocOrder(
    $input: UpdateMultipleImmigrationDocsInput!
  ) {
    updateMultipleImmigrationDocs(input: $input) {
      clientMutationId
    }
  }
`;
export type UpdateImmigrationDocOrderMutationFn = Apollo.MutationFunction<
  Types.UpdateImmigrationDocOrderMutation,
  Types.UpdateImmigrationDocOrderMutationVariables
>;

/**
 * __useUpdateImmigrationDocOrderMutation__
 *
 * To run a mutation, you first call `useUpdateImmigrationDocOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImmigrationDocOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImmigrationDocOrderMutation, { data, loading, error }] = useUpdateImmigrationDocOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImmigrationDocOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateImmigrationDocOrderMutation,
    Types.UpdateImmigrationDocOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateImmigrationDocOrderMutation,
    Types.UpdateImmigrationDocOrderMutationVariables
  >(UpdateImmigrationDocOrderDocument, options);
}
export type UpdateImmigrationDocOrderMutationHookResult = ReturnType<
  typeof useUpdateImmigrationDocOrderMutation
>;
export type UpdateImmigrationDocOrderMutationResult =
  Apollo.MutationResult<Types.UpdateImmigrationDocOrderMutation>;
export type UpdateImmigrationDocOrderMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateImmigrationDocOrderMutation,
    Types.UpdateImmigrationDocOrderMutationVariables
  >;
export const UpdateImmigrationDocumentDocument = /*#__PURE__*/ gql`
  mutation UpdateImmigrationDocument($input: UpdateImmigrationDocumentInput!) {
    updateImmigrationDocument(input: $input) {
      clientMutationId
      immigrationDocument {
        nodeId
        deleted
        fileId
      }
    }
  }
`;
export type UpdateImmigrationDocumentMutationFn = Apollo.MutationFunction<
  Types.UpdateImmigrationDocumentMutation,
  Types.UpdateImmigrationDocumentMutationVariables
>;

/**
 * __useUpdateImmigrationDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateImmigrationDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImmigrationDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImmigrationDocumentMutation, { data, loading, error }] = useUpdateImmigrationDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImmigrationDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateImmigrationDocumentMutation,
    Types.UpdateImmigrationDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateImmigrationDocumentMutation,
    Types.UpdateImmigrationDocumentMutationVariables
  >(UpdateImmigrationDocumentDocument, options);
}
export type UpdateImmigrationDocumentMutationHookResult = ReturnType<
  typeof useUpdateImmigrationDocumentMutation
>;
export type UpdateImmigrationDocumentMutationResult =
  Apollo.MutationResult<Types.UpdateImmigrationDocumentMutation>;
export type UpdateImmigrationDocumentMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateImmigrationDocumentMutation,
    Types.UpdateImmigrationDocumentMutationVariables
  >;
export const CreateCompanyMemberDocument = /*#__PURE__*/ gql`
  mutation CreateCompanyMember($input: CreateCompanyMemberInput!) {
    createCompanyMember(input: $input) {
      companyByCompanyId {
        nodeId
        companyMembersByCompanyId {
          nodes {
            nodeId
            userByUserId {
              fullName
            }
          }
        }
      }
    }
  }
`;
export type CreateCompanyMemberMutationFn = Apollo.MutationFunction<
  Types.CreateCompanyMemberMutation,
  Types.CreateCompanyMemberMutationVariables
>;

/**
 * __useCreateCompanyMemberMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMemberMutation, { data, loading, error }] = useCreateCompanyMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateCompanyMemberMutation,
    Types.CreateCompanyMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateCompanyMemberMutation,
    Types.CreateCompanyMemberMutationVariables
  >(CreateCompanyMemberDocument, options);
}
export type CreateCompanyMemberMutationHookResult = ReturnType<
  typeof useCreateCompanyMemberMutation
>;
export type CreateCompanyMemberMutationResult =
  Apollo.MutationResult<Types.CreateCompanyMemberMutation>;
export type CreateCompanyMemberMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateCompanyMemberMutation,
  Types.CreateCompanyMemberMutationVariables
>;
export const EntitiesByTypeDocument = /*#__PURE__*/ gql`
  query EntitiesByType($type: EntityTypes) {
    allAdditionalEntities(condition: { type: $type }) {
      nodes {
        name
        id
        type
        companyByCompanyId {
          dbaName
        }
        userByUserId {
          fullName
        }
      }
    }
  }
`;

/**
 * __useEntitiesByTypeQuery__
 *
 * To run a query within a React component, call `useEntitiesByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitiesByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitiesByTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useEntitiesByTypeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.EntitiesByTypeQuery,
    Types.EntitiesByTypeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.EntitiesByTypeQuery,
    Types.EntitiesByTypeQueryVariables
  >(EntitiesByTypeDocument, options);
}
export function useEntitiesByTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.EntitiesByTypeQuery,
    Types.EntitiesByTypeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.EntitiesByTypeQuery,
    Types.EntitiesByTypeQueryVariables
  >(EntitiesByTypeDocument, options);
}
export type EntitiesByTypeQueryHookResult = ReturnType<
  typeof useEntitiesByTypeQuery
>;
export type EntitiesByTypeLazyQueryHookResult = ReturnType<
  typeof useEntitiesByTypeLazyQuery
>;
export type EntitiesByTypeQueryResult = Apollo.QueryResult<
  Types.EntitiesByTypeQuery,
  Types.EntitiesByTypeQueryVariables
>;
export const CreateReusableExhibitDocument = /*#__PURE__*/ gql`
  mutation createReusableExhibit($input: CreateReusableExhibitInput!) {
    createReusableExhibit(input: $input) {
      clientMutationId
    }
  }
`;
export type CreateReusableExhibitMutationFn = Apollo.MutationFunction<
  Types.CreateReusableExhibitMutation,
  Types.CreateReusableExhibitMutationVariables
>;

/**
 * __useCreateReusableExhibitMutation__
 *
 * To run a mutation, you first call `useCreateReusableExhibitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReusableExhibitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReusableExhibitMutation, { data, loading, error }] = useCreateReusableExhibitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReusableExhibitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateReusableExhibitMutation,
    Types.CreateReusableExhibitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateReusableExhibitMutation,
    Types.CreateReusableExhibitMutationVariables
  >(CreateReusableExhibitDocument, options);
}
export type CreateReusableExhibitMutationHookResult = ReturnType<
  typeof useCreateReusableExhibitMutation
>;
export type CreateReusableExhibitMutationResult =
  Apollo.MutationResult<Types.CreateReusableExhibitMutation>;
export type CreateReusableExhibitMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateReusableExhibitMutation,
  Types.CreateReusableExhibitMutationVariables
>;
export const UserFormDatumDocument = /*#__PURE__*/ gql`
  query UserFormDatum($id: BigInt!) {
    userById(id: $id) {
      nodeId
      id
      fullName
      firstName
      middleName
      lastName
      userDatumById {
        passportNumberPassportOcr
        cityOfIssuePassportOcr
        countryOfIssuePassportOcr
        expirationDatePassportOcr
        dateOfIssuePassportOcr
        placeOfBirthPassportOcr
        surnamePassportOcr
        givenNamePassportOcr
        middleNamePassportOcr
      }
    }
  }
`;

/**
 * __useUserFormDatumQuery__
 *
 * To run a query within a React component, call `useUserFormDatumQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFormDatumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFormDatumQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserFormDatumQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.UserFormDatumQuery,
    Types.UserFormDatumQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.UserFormDatumQuery,
    Types.UserFormDatumQueryVariables
  >(UserFormDatumDocument, options);
}
export function useUserFormDatumLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.UserFormDatumQuery,
    Types.UserFormDatumQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.UserFormDatumQuery,
    Types.UserFormDatumQueryVariables
  >(UserFormDatumDocument, options);
}
export type UserFormDatumQueryHookResult = ReturnType<
  typeof useUserFormDatumQuery
>;
export type UserFormDatumLazyQueryHookResult = ReturnType<
  typeof useUserFormDatumLazyQuery
>;
export type UserFormDatumQueryResult = Apollo.QueryResult<
  Types.UserFormDatumQuery,
  Types.UserFormDatumQueryVariables
>;
export const AllCompanyOfficesDocument = /*#__PURE__*/ gql`
  query AllCompanyOffices($id: BigInt!) {
    companyById(id: $id) {
      companyOfficesByCompanyId {
        nodes {
          id
          label
          postalCode
          state
          street
          street2
          unitType
          unitNumber
          country
          city
          isEmployeeWorksite
        }
      }
    }
  }
`;

/**
 * __useAllCompanyOfficesQuery__
 *
 * To run a query within a React component, call `useAllCompanyOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCompanyOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCompanyOfficesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAllCompanyOfficesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.AllCompanyOfficesQuery,
    Types.AllCompanyOfficesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllCompanyOfficesQuery,
    Types.AllCompanyOfficesQueryVariables
  >(AllCompanyOfficesDocument, options);
}
export function useAllCompanyOfficesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllCompanyOfficesQuery,
    Types.AllCompanyOfficesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllCompanyOfficesQuery,
    Types.AllCompanyOfficesQueryVariables
  >(AllCompanyOfficesDocument, options);
}
export type AllCompanyOfficesQueryHookResult = ReturnType<
  typeof useAllCompanyOfficesQuery
>;
export type AllCompanyOfficesLazyQueryHookResult = ReturnType<
  typeof useAllCompanyOfficesLazyQuery
>;
export type AllCompanyOfficesQueryResult = Apollo.QueryResult<
  Types.AllCompanyOfficesQuery,
  Types.AllCompanyOfficesQueryVariables
>;
export const RemoveCompanyMemberDocument = /*#__PURE__*/ gql`
  mutation RemoveCompanyMember(
    $input: DeleteCompanyMemberByCompanyIdAndUserIdInput!
  ) {
    deleteCompanyMemberByCompanyIdAndUserId(input: $input) {
      companyMember {
        companyId
        userId
        role
        isAuthorizedSignatory
      }
    }
  }
`;
export type RemoveCompanyMemberMutationFn = Apollo.MutationFunction<
  Types.RemoveCompanyMemberMutation,
  Types.RemoveCompanyMemberMutationVariables
>;

/**
 * __useRemoveCompanyMemberMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyMemberMutation, { data, loading, error }] = useRemoveCompanyMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCompanyMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.RemoveCompanyMemberMutation,
    Types.RemoveCompanyMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.RemoveCompanyMemberMutation,
    Types.RemoveCompanyMemberMutationVariables
  >(RemoveCompanyMemberDocument, options);
}
export type RemoveCompanyMemberMutationHookResult = ReturnType<
  typeof useRemoveCompanyMemberMutation
>;
export type RemoveCompanyMemberMutationResult =
  Apollo.MutationResult<Types.RemoveCompanyMemberMutation>;
export type RemoveCompanyMemberMutationOptions = Apollo.BaseMutationOptions<
  Types.RemoveCompanyMemberMutation,
  Types.RemoveCompanyMemberMutationVariables
>;
export const AllExhibitTypesDocument = /*#__PURE__*/ gql`
  query AllExhibitTypes {
    allExhibitTypes {
      nodes {
        id
        name
      }
    }
  }
`;

/**
 * __useAllExhibitTypesQuery__
 *
 * To run a query within a React component, call `useAllExhibitTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllExhibitTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllExhibitTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllExhibitTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AllExhibitTypesQuery,
    Types.AllExhibitTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllExhibitTypesQuery,
    Types.AllExhibitTypesQueryVariables
  >(AllExhibitTypesDocument, options);
}
export function useAllExhibitTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllExhibitTypesQuery,
    Types.AllExhibitTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllExhibitTypesQuery,
    Types.AllExhibitTypesQueryVariables
  >(AllExhibitTypesDocument, options);
}
export type AllExhibitTypesQueryHookResult = ReturnType<
  typeof useAllExhibitTypesQuery
>;
export type AllExhibitTypesLazyQueryHookResult = ReturnType<
  typeof useAllExhibitTypesLazyQuery
>;
export type AllExhibitTypesQueryResult = Apollo.QueryResult<
  Types.AllExhibitTypesQuery,
  Types.AllExhibitTypesQueryVariables
>;
export const DeleteCompanyOfficeByIdDocument = /*#__PURE__*/ gql`
  mutation DeleteCompanyOfficeById($input: DeleteCompanyOfficeByIdInput!) {
    deleteCompanyOfficeById(input: $input) {
      deletedCompanyOfficeId
    }
  }
`;
export type DeleteCompanyOfficeByIdMutationFn = Apollo.MutationFunction<
  Types.DeleteCompanyOfficeByIdMutation,
  Types.DeleteCompanyOfficeByIdMutationVariables
>;

/**
 * __useDeleteCompanyOfficeByIdMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyOfficeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyOfficeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyOfficeByIdMutation, { data, loading, error }] = useDeleteCompanyOfficeByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCompanyOfficeByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteCompanyOfficeByIdMutation,
    Types.DeleteCompanyOfficeByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DeleteCompanyOfficeByIdMutation,
    Types.DeleteCompanyOfficeByIdMutationVariables
  >(DeleteCompanyOfficeByIdDocument, options);
}
export type DeleteCompanyOfficeByIdMutationHookResult = ReturnType<
  typeof useDeleteCompanyOfficeByIdMutation
>;
export type DeleteCompanyOfficeByIdMutationResult =
  Apollo.MutationResult<Types.DeleteCompanyOfficeByIdMutation>;
export type DeleteCompanyOfficeByIdMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteCompanyOfficeByIdMutation,
  Types.DeleteCompanyOfficeByIdMutationVariables
>;
export const ExhibitFilesDocument = /*#__PURE__*/ gql`
  query ExhibitFiles($id: BigInt!) {
    exhibitById(id: $id) {
      name
      exhibitFilesByExhibitId(orderBy: ORDER_INDEX_ASC) {
        nodes {
          fileByFileId {
            id
            name
            mimeType
            createdAt
          }
          orderIndex
        }
      }
    }
  }
`;

/**
 * __useExhibitFilesQuery__
 *
 * To run a query within a React component, call `useExhibitFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExhibitFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExhibitFilesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExhibitFilesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.ExhibitFilesQuery,
    Types.ExhibitFilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ExhibitFilesQuery,
    Types.ExhibitFilesQueryVariables
  >(ExhibitFilesDocument, options);
}
export function useExhibitFilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ExhibitFilesQuery,
    Types.ExhibitFilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ExhibitFilesQuery,
    Types.ExhibitFilesQueryVariables
  >(ExhibitFilesDocument, options);
}
export type ExhibitFilesQueryHookResult = ReturnType<
  typeof useExhibitFilesQuery
>;
export type ExhibitFilesLazyQueryHookResult = ReturnType<
  typeof useExhibitFilesLazyQuery
>;
export type ExhibitFilesQueryResult = Apollo.QueryResult<
  Types.ExhibitFilesQuery,
  Types.ExhibitFilesQueryVariables
>;
export const PetitionFormByIdDocument = /*#__PURE__*/ gql`
  query PetitionFormById($id: BigInt!) {
    petitionFormById(id: $id) {
      fileByFileId {
        id
        name
      }
    }
  }
`;

/**
 * __usePetitionFormByIdQuery__
 *
 * To run a query within a React component, call `usePetitionFormByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePetitionFormByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetitionFormByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePetitionFormByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PetitionFormByIdQuery,
    Types.PetitionFormByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PetitionFormByIdQuery,
    Types.PetitionFormByIdQueryVariables
  >(PetitionFormByIdDocument, options);
}
export function usePetitionFormByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PetitionFormByIdQuery,
    Types.PetitionFormByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PetitionFormByIdQuery,
    Types.PetitionFormByIdQueryVariables
  >(PetitionFormByIdDocument, options);
}
export type PetitionFormByIdQueryHookResult = ReturnType<
  typeof usePetitionFormByIdQuery
>;
export type PetitionFormByIdLazyQueryHookResult = ReturnType<
  typeof usePetitionFormByIdLazyQuery
>;
export type PetitionFormByIdQueryResult = Apollo.QueryResult<
  Types.PetitionFormByIdQuery,
  Types.PetitionFormByIdQueryVariables
>;
export const ImmigrationDocsSubDocument = /*#__PURE__*/ gql`
  subscription ImmigrationDocsSub($wsId: String!) {
    immigrationDocsUpdated(wsId: $wsId) {
      id
    }
  }
`;

/**
 * __useImmigrationDocsSubSubscription__
 *
 * To run a query within a React component, call `useImmigrationDocsSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useImmigrationDocsSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImmigrationDocsSubSubscription({
 *   variables: {
 *      wsId: // value for 'wsId'
 *   },
 * });
 */
export function useImmigrationDocsSubSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types.ImmigrationDocsSubSubscription,
    Types.ImmigrationDocsSubSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    Types.ImmigrationDocsSubSubscription,
    Types.ImmigrationDocsSubSubscriptionVariables
  >(ImmigrationDocsSubDocument, options);
}
export type ImmigrationDocsSubSubscriptionHookResult = ReturnType<
  typeof useImmigrationDocsSubSubscription
>;
export type ImmigrationDocsSubSubscriptionResult =
  Apollo.SubscriptionResult<Types.ImmigrationDocsSubSubscription>;
export const CompanyDocsSubDocument = /*#__PURE__*/ gql`
  subscription CompanyDocsSub($wsId: String!) {
    companyDocsUpdated(wsId: $wsId) {
      id
    }
  }
`;

/**
 * __useCompanyDocsSubSubscription__
 *
 * To run a query within a React component, call `useCompanyDocsSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDocsSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDocsSubSubscription({
 *   variables: {
 *      wsId: // value for 'wsId'
 *   },
 * });
 */
export function useCompanyDocsSubSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Types.CompanyDocsSubSubscription,
    Types.CompanyDocsSubSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    Types.CompanyDocsSubSubscription,
    Types.CompanyDocsSubSubscriptionVariables
  >(CompanyDocsSubDocument, options);
}
export type CompanyDocsSubSubscriptionHookResult = ReturnType<
  typeof useCompanyDocsSubSubscription
>;
export type CompanyDocsSubSubscriptionResult =
  Apollo.SubscriptionResult<Types.CompanyDocsSubSubscription>;
export const LetterGenContactDataDocument = /*#__PURE__*/ gql`
  query LetterGenContactData {
    allUsers {
      nodes {
        bio
        fullName
        id
      }
    }
    allCompanies {
      nodes {
        id
        dbaName
        bio
      }
    }
  }
`;

/**
 * __useLetterGenContactDataQuery__
 *
 * To run a query within a React component, call `useLetterGenContactDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLetterGenContactDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLetterGenContactDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useLetterGenContactDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.LetterGenContactDataQuery,
    Types.LetterGenContactDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.LetterGenContactDataQuery,
    Types.LetterGenContactDataQueryVariables
  >(LetterGenContactDataDocument, options);
}
export function useLetterGenContactDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.LetterGenContactDataQuery,
    Types.LetterGenContactDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.LetterGenContactDataQuery,
    Types.LetterGenContactDataQueryVariables
  >(LetterGenContactDataDocument, options);
}
export type LetterGenContactDataQueryHookResult = ReturnType<
  typeof useLetterGenContactDataQuery
>;
export type LetterGenContactDataLazyQueryHookResult = ReturnType<
  typeof useLetterGenContactDataLazyQuery
>;
export type LetterGenContactDataQueryResult = Apollo.QueryResult<
  Types.LetterGenContactDataQuery,
  Types.LetterGenContactDataQueryVariables
>;
export const CreateUserDocument = /*#__PURE__*/ gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      user {
        id
        fullName
        firstName
        middleName
        lastName
        bio
        additionalEntitiesByUserId {
          nodes {
            id
          }
        }
      }
    }
  }
`;
export type CreateUserMutationFn = Apollo.MutationFunction<
  Types.CreateUserMutation,
  Types.CreateUserMutationVariables
>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateUserMutation,
    Types.CreateUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateUserMutation,
    Types.CreateUserMutationVariables
  >(CreateUserDocument, options);
}
export type CreateUserMutationHookResult = ReturnType<
  typeof useCreateUserMutation
>;
export type CreateUserMutationResult =
  Apollo.MutationResult<Types.CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateUserMutation,
  Types.CreateUserMutationVariables
>;
export const CreateCompanyDocument = /*#__PURE__*/ gql`
  mutation CreateCompany($input: CreateCompanyInput!) {
    createCompany(input: $input) {
      company {
        dbaName
        bio
        additionalEntitiesByCompanyId {
          nodes {
            id
          }
        }
      }
    }
  }
`;
export type CreateCompanyMutationFn = Apollo.MutationFunction<
  Types.CreateCompanyMutation,
  Types.CreateCompanyMutationVariables
>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateCompanyMutation,
    Types.CreateCompanyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateCompanyMutation,
    Types.CreateCompanyMutationVariables
  >(CreateCompanyDocument, options);
}
export type CreateCompanyMutationHookResult = ReturnType<
  typeof useCreateCompanyMutation
>;
export type CreateCompanyMutationResult =
  Apollo.MutationResult<Types.CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateCompanyMutation,
  Types.CreateCompanyMutationVariables
>;
export const CreateEntityDocument = /*#__PURE__*/ gql`
  mutation CreateEntity($input: CreateAdditionalEntityInput!) {
    createAdditionalEntity(input: $input) {
      additionalEntity {
        id
      }
    }
  }
`;
export type CreateEntityMutationFn = Apollo.MutationFunction<
  Types.CreateEntityMutation,
  Types.CreateEntityMutationVariables
>;

/**
 * __useCreateEntityMutation__
 *
 * To run a mutation, you first call `useCreateEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityMutation, { data, loading, error }] = useCreateEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEntityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateEntityMutation,
    Types.CreateEntityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateEntityMutation,
    Types.CreateEntityMutationVariables
  >(CreateEntityDocument, options);
}
export type CreateEntityMutationHookResult = ReturnType<
  typeof useCreateEntityMutation
>;
export type CreateEntityMutationResult =
  Apollo.MutationResult<Types.CreateEntityMutation>;
export type CreateEntityMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateEntityMutation,
  Types.CreateEntityMutationVariables
>;
export const AllPetitionFormsDocument = /*#__PURE__*/ gql`
  query AllPetitionForms($petitionId: BigInt!) {
    allPetitionForms(condition: { petitionId: $petitionId }) {
      nodes {
        id
        type
        fileByFileId {
          id
          createdAt
        }
      }
    }
  }
`;

/**
 * __useAllPetitionFormsQuery__
 *
 * To run a query within a React component, call `useAllPetitionFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPetitionFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPetitionFormsQuery({
 *   variables: {
 *      petitionId: // value for 'petitionId'
 *   },
 * });
 */
export function useAllPetitionFormsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.AllPetitionFormsQuery,
    Types.AllPetitionFormsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllPetitionFormsQuery,
    Types.AllPetitionFormsQueryVariables
  >(AllPetitionFormsDocument, options);
}
export function useAllPetitionFormsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllPetitionFormsQuery,
    Types.AllPetitionFormsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllPetitionFormsQuery,
    Types.AllPetitionFormsQueryVariables
  >(AllPetitionFormsDocument, options);
}
export type AllPetitionFormsQueryHookResult = ReturnType<
  typeof useAllPetitionFormsQuery
>;
export type AllPetitionFormsLazyQueryHookResult = ReturnType<
  typeof useAllPetitionFormsLazyQuery
>;
export type AllPetitionFormsQueryResult = Apollo.QueryResult<
  Types.AllPetitionFormsQuery,
  Types.AllPetitionFormsQueryVariables
>;
export const EntitiesPageDocument = /*#__PURE__*/ gql`
  query EntitiesPage {
    allCompanies {
      nodes {
        id
        dbaName
        bio
      }
      totalCount
    }
    allUsers {
      totalCount
      nodes {
        bio
        firstName
        fullName
        id
        lastName
        middleName
      }
    }
  }
`;

/**
 * __useEntitiesPageQuery__
 *
 * To run a query within a React component, call `useEntitiesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitiesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitiesPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntitiesPageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.EntitiesPageQuery,
    Types.EntitiesPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.EntitiesPageQuery,
    Types.EntitiesPageQueryVariables
  >(EntitiesPageDocument, options);
}
export function useEntitiesPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.EntitiesPageQuery,
    Types.EntitiesPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.EntitiesPageQuery,
    Types.EntitiesPageQueryVariables
  >(EntitiesPageDocument, options);
}
export type EntitiesPageQueryHookResult = ReturnType<
  typeof useEntitiesPageQuery
>;
export type EntitiesPageLazyQueryHookResult = ReturnType<
  typeof useEntitiesPageLazyQuery
>;
export type EntitiesPageQueryResult = Apollo.QueryResult<
  Types.EntitiesPageQuery,
  Types.EntitiesPageQueryVariables
>;
export const EntitiesPageStatsDocument = /*#__PURE__*/ gql`
  query EntitiesPageStats {
    allCompanies {
      totalCount
    }
    allUsers {
      totalCount
    }
  }
`;

/**
 * __useEntitiesPageStatsQuery__
 *
 * To run a query within a React component, call `useEntitiesPageStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitiesPageStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitiesPageStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntitiesPageStatsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.EntitiesPageStatsQuery,
    Types.EntitiesPageStatsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.EntitiesPageStatsQuery,
    Types.EntitiesPageStatsQueryVariables
  >(EntitiesPageStatsDocument, options);
}
export function useEntitiesPageStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.EntitiesPageStatsQuery,
    Types.EntitiesPageStatsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.EntitiesPageStatsQuery,
    Types.EntitiesPageStatsQueryVariables
  >(EntitiesPageStatsDocument, options);
}
export type EntitiesPageStatsQueryHookResult = ReturnType<
  typeof useEntitiesPageStatsQuery
>;
export type EntitiesPageStatsLazyQueryHookResult = ReturnType<
  typeof useEntitiesPageStatsLazyQuery
>;
export type EntitiesPageStatsQueryResult = Apollo.QueryResult<
  Types.EntitiesPageStatsQuery,
  Types.EntitiesPageStatsQueryVariables
>;
export const AdditionalEntitiesDocument = /*#__PURE__*/ gql`
  query AdditionalEntities {
    allAdditionalEntities {
      nodes {
        id
        name
        type
        data
        userByUserId {
          fullName
          firstName
          middleName
          lastName
          id
          bio
        }
        companyByCompanyId {
          id
          dbaName
          bio
        }
      }
    }
  }
`;

/**
 * __useAdditionalEntitiesQuery__
 *
 * To run a query within a React component, call `useAdditionalEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdditionalEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdditionalEntitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdditionalEntitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AdditionalEntitiesQuery,
    Types.AdditionalEntitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AdditionalEntitiesQuery,
    Types.AdditionalEntitiesQueryVariables
  >(AdditionalEntitiesDocument, options);
}
export function useAdditionalEntitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AdditionalEntitiesQuery,
    Types.AdditionalEntitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AdditionalEntitiesQuery,
    Types.AdditionalEntitiesQueryVariables
  >(AdditionalEntitiesDocument, options);
}
export type AdditionalEntitiesQueryHookResult = ReturnType<
  typeof useAdditionalEntitiesQuery
>;
export type AdditionalEntitiesLazyQueryHookResult = ReturnType<
  typeof useAdditionalEntitiesLazyQuery
>;
export type AdditionalEntitiesQueryResult = Apollo.QueryResult<
  Types.AdditionalEntitiesQuery,
  Types.AdditionalEntitiesQueryVariables
>;
export const GetEntityDocument = /*#__PURE__*/ gql`
  query GetEntity($id: BigInt!, $entityType: EntityTypes!) {
    additionalEntityById(id: $id) {
      id
      name
      type
      data
      userByUserId {
        ...User
        immigrationDocumentsByOwnerId(orderBy: ORDER_INDEX_ASC) {
          nodes {
            type
            fileByFileId {
              id
              name
            }
          }
        }
      }
      companyByCompanyId {
        ...CompanyEntity
      }
    }
    entitySchemaByEntityType(entityType: $entityType) {
      schema
    }
  }
  ${UserFragmentDoc}
  ${UserDatumFragmentDoc}
  ${CompanyEntityFragmentDoc}
`;

/**
 * __useGetEntityQuery__
 *
 * To run a query within a React component, call `useGetEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useGetEntityQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetEntityQuery,
    Types.GetEntityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetEntityQuery, Types.GetEntityQueryVariables>(
    GetEntityDocument,
    options
  );
}
export function useGetEntityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetEntityQuery,
    Types.GetEntityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetEntityQuery,
    Types.GetEntityQueryVariables
  >(GetEntityDocument, options);
}
export type GetEntityQueryHookResult = ReturnType<typeof useGetEntityQuery>;
export type GetEntityLazyQueryHookResult = ReturnType<
  typeof useGetEntityLazyQuery
>;
export type GetEntityQueryResult = Apollo.QueryResult<
  Types.GetEntityQuery,
  Types.GetEntityQueryVariables
>;
export const UpdateAdditionalEntityByIdDocument = /*#__PURE__*/ gql`
  mutation UpdateAdditionalEntityById(
    $input: UpdateAdditionalEntityByIdInput!
  ) {
    updateAdditionalEntityById(input: $input) {
      clientMutationId
    }
  }
`;
export type UpdateAdditionalEntityByIdMutationFn = Apollo.MutationFunction<
  Types.UpdateAdditionalEntityByIdMutation,
  Types.UpdateAdditionalEntityByIdMutationVariables
>;

/**
 * __useUpdateAdditionalEntityByIdMutation__
 *
 * To run a mutation, you first call `useUpdateAdditionalEntityByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdditionalEntityByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdditionalEntityByIdMutation, { data, loading, error }] = useUpdateAdditionalEntityByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdditionalEntityByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateAdditionalEntityByIdMutation,
    Types.UpdateAdditionalEntityByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateAdditionalEntityByIdMutation,
    Types.UpdateAdditionalEntityByIdMutationVariables
  >(UpdateAdditionalEntityByIdDocument, options);
}
export type UpdateAdditionalEntityByIdMutationHookResult = ReturnType<
  typeof useUpdateAdditionalEntityByIdMutation
>;
export type UpdateAdditionalEntityByIdMutationResult =
  Apollo.MutationResult<Types.UpdateAdditionalEntityByIdMutation>;
export type UpdateAdditionalEntityByIdMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateAdditionalEntityByIdMutation,
    Types.UpdateAdditionalEntityByIdMutationVariables
  >;
export const AllReusableExhibitsDocument = /*#__PURE__*/ gql`
  query AllReusableExhibits {
    allReusableExhibits(condition: { parentExhibitId: null, deleted: false }) {
      nodes {
        id
        name
        description
        deleted
        moduleTypeByModuleType {
          id
          name
        }
        exhibitTypeByExhibitType {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useAllReusableExhibitsQuery__
 *
 * To run a query within a React component, call `useAllReusableExhibitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllReusableExhibitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllReusableExhibitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllReusableExhibitsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AllReusableExhibitsQuery,
    Types.AllReusableExhibitsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllReusableExhibitsQuery,
    Types.AllReusableExhibitsQueryVariables
  >(AllReusableExhibitsDocument, options);
}
export function useAllReusableExhibitsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllReusableExhibitsQuery,
    Types.AllReusableExhibitsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllReusableExhibitsQuery,
    Types.AllReusableExhibitsQueryVariables
  >(AllReusableExhibitsDocument, options);
}
export type AllReusableExhibitsQueryHookResult = ReturnType<
  typeof useAllReusableExhibitsQuery
>;
export type AllReusableExhibitsLazyQueryHookResult = ReturnType<
  typeof useAllReusableExhibitsLazyQuery
>;
export type AllReusableExhibitsQueryResult = Apollo.QueryResult<
  Types.AllReusableExhibitsQuery,
  Types.AllReusableExhibitsQueryVariables
>;
export const ExhibitRepoQueryDocument = /*#__PURE__*/ gql`
  query ExhibitRepoQuery {
    allExhibitTypes {
      nodes {
        id
        name
      }
    }
    allModuleTypes {
      nodes {
        id
        name
      }
    }
  }
`;

/**
 * __useExhibitRepoQueryQuery__
 *
 * To run a query within a React component, call `useExhibitRepoQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExhibitRepoQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExhibitRepoQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useExhibitRepoQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.ExhibitRepoQueryQuery,
    Types.ExhibitRepoQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ExhibitRepoQueryQuery,
    Types.ExhibitRepoQueryQueryVariables
  >(ExhibitRepoQueryDocument, options);
}
export function useExhibitRepoQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ExhibitRepoQueryQuery,
    Types.ExhibitRepoQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ExhibitRepoQueryQuery,
    Types.ExhibitRepoQueryQueryVariables
  >(ExhibitRepoQueryDocument, options);
}
export type ExhibitRepoQueryQueryHookResult = ReturnType<
  typeof useExhibitRepoQueryQuery
>;
export type ExhibitRepoQueryLazyQueryHookResult = ReturnType<
  typeof useExhibitRepoQueryLazyQuery
>;
export type ExhibitRepoQueryQueryResult = Apollo.QueryResult<
  Types.ExhibitRepoQueryQuery,
  Types.ExhibitRepoQueryQueryVariables
>;
export const ReusableExhibitByIdDocument = /*#__PURE__*/ gql`
  query ReusableExhibitById($id: BigInt!) {
    reusableExhibitById(id: $id) {
      id
      name
      description
      visible
      ownedBy
      deleted
      reusableExhibitFilesByReusableExhibitId {
        nodes {
          fileByFileId {
            id
            name
          }
        }
      }
      exhibitTypeByExhibitType {
        id
        name
      }
      moduleTypeByModuleType {
        id
        name
      }
      reusableExhibitEntitiesByReusableExhibitId {
        nodes {
          additionalEntityByEntityId {
            id
            name
            type
            companyByCompanyId {
              id
              dbaName
            }
            userByUserId {
              id
              fullName
            }
          }
        }
      }
      reusableExhibitsByParentExhibitId(condition: { deleted: false }) {
        nodes {
          id
          name
          description
          exhibitTypeByExhibitType {
            id
            name
            __typename
          }
          moduleTypeByModuleType {
            id
            name
            __typename
          }
          reusableExhibitFilesByReusableExhibitId {
            nodes {
              fileByFileId {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useReusableExhibitByIdQuery__
 *
 * To run a query within a React component, call `useReusableExhibitByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useReusableExhibitByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReusableExhibitByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReusableExhibitByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.ReusableExhibitByIdQuery,
    Types.ReusableExhibitByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ReusableExhibitByIdQuery,
    Types.ReusableExhibitByIdQueryVariables
  >(ReusableExhibitByIdDocument, options);
}
export function useReusableExhibitByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ReusableExhibitByIdQuery,
    Types.ReusableExhibitByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ReusableExhibitByIdQuery,
    Types.ReusableExhibitByIdQueryVariables
  >(ReusableExhibitByIdDocument, options);
}
export type ReusableExhibitByIdQueryHookResult = ReturnType<
  typeof useReusableExhibitByIdQuery
>;
export type ReusableExhibitByIdLazyQueryHookResult = ReturnType<
  typeof useReusableExhibitByIdLazyQuery
>;
export type ReusableExhibitByIdQueryResult = Apollo.QueryResult<
  Types.ReusableExhibitByIdQuery,
  Types.ReusableExhibitByIdQueryVariables
>;
export const UpdateResuableExhibitDocument = /*#__PURE__*/ gql`
  mutation UpdateResuableExhibit($input: UpdateReusableExhibitByIdInput!) {
    updateReusableExhibitById(input: $input) {
      reusableExhibit {
        id
        name
        deleted
        visible
        description
      }
    }
  }
`;
export type UpdateResuableExhibitMutationFn = Apollo.MutationFunction<
  Types.UpdateResuableExhibitMutation,
  Types.UpdateResuableExhibitMutationVariables
>;

/**
 * __useUpdateResuableExhibitMutation__
 *
 * To run a mutation, you first call `useUpdateResuableExhibitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResuableExhibitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResuableExhibitMutation, { data, loading, error }] = useUpdateResuableExhibitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResuableExhibitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateResuableExhibitMutation,
    Types.UpdateResuableExhibitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateResuableExhibitMutation,
    Types.UpdateResuableExhibitMutationVariables
  >(UpdateResuableExhibitDocument, options);
}
export type UpdateResuableExhibitMutationHookResult = ReturnType<
  typeof useUpdateResuableExhibitMutation
>;
export type UpdateResuableExhibitMutationResult =
  Apollo.MutationResult<Types.UpdateResuableExhibitMutation>;
export type UpdateResuableExhibitMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateResuableExhibitMutation,
  Types.UpdateResuableExhibitMutationVariables
>;
export const UpdateReusableExhibitFilesOrderDocument = /*#__PURE__*/ gql`
  mutation UpdateReusableExhibitFilesOrder(
    $input: UpdateMultipleReusableExhibitFilesInput!
  ) {
    updateMultipleReusableExhibitFiles(input: $input) {
      clientMutationId
    }
  }
`;
export type UpdateReusableExhibitFilesOrderMutationFn = Apollo.MutationFunction<
  Types.UpdateReusableExhibitFilesOrderMutation,
  Types.UpdateReusableExhibitFilesOrderMutationVariables
>;

/**
 * __useUpdateReusableExhibitFilesOrderMutation__
 *
 * To run a mutation, you first call `useUpdateReusableExhibitFilesOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReusableExhibitFilesOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReusableExhibitFilesOrderMutation, { data, loading, error }] = useUpdateReusableExhibitFilesOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReusableExhibitFilesOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateReusableExhibitFilesOrderMutation,
    Types.UpdateReusableExhibitFilesOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateReusableExhibitFilesOrderMutation,
    Types.UpdateReusableExhibitFilesOrderMutationVariables
  >(UpdateReusableExhibitFilesOrderDocument, options);
}
export type UpdateReusableExhibitFilesOrderMutationHookResult = ReturnType<
  typeof useUpdateReusableExhibitFilesOrderMutation
>;
export type UpdateReusableExhibitFilesOrderMutationResult =
  Apollo.MutationResult<Types.UpdateReusableExhibitFilesOrderMutation>;
export type UpdateReusableExhibitFilesOrderMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateReusableExhibitFilesOrderMutation,
    Types.UpdateReusableExhibitFilesOrderMutationVariables
  >;
export const UpdateReusableSubexhibitOrderDocument = /*#__PURE__*/ gql`
  mutation UpdateReusableSubexhibitOrder(
    $input: UpdateMultipleReusableExhibitsOrderInput!
  ) {
    updateMultipleReusableExhibitsOrder(input: $input) {
      clientMutationId
    }
  }
`;
export type UpdateReusableSubexhibitOrderMutationFn = Apollo.MutationFunction<
  Types.UpdateReusableSubexhibitOrderMutation,
  Types.UpdateReusableSubexhibitOrderMutationVariables
>;

/**
 * __useUpdateReusableSubexhibitOrderMutation__
 *
 * To run a mutation, you first call `useUpdateReusableSubexhibitOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReusableSubexhibitOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReusableSubexhibitOrderMutation, { data, loading, error }] = useUpdateReusableSubexhibitOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReusableSubexhibitOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateReusableSubexhibitOrderMutation,
    Types.UpdateReusableSubexhibitOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateReusableSubexhibitOrderMutation,
    Types.UpdateReusableSubexhibitOrderMutationVariables
  >(UpdateReusableSubexhibitOrderDocument, options);
}
export type UpdateReusableSubexhibitOrderMutationHookResult = ReturnType<
  typeof useUpdateReusableSubexhibitOrderMutation
>;
export type UpdateReusableSubexhibitOrderMutationResult =
  Apollo.MutationResult<Types.UpdateReusableSubexhibitOrderMutation>;
export type UpdateReusableSubexhibitOrderMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateReusableSubexhibitOrderMutation,
    Types.UpdateReusableSubexhibitOrderMutationVariables
  >;
export const CreateReusableExhibitEntityDocument = /*#__PURE__*/ gql`
  mutation CreateReusableExhibitEntity(
    $input: CreateReusableExhibitEntityInput!
  ) {
    createReusableExhibitEntity(input: $input) {
      clientMutationId
    }
  }
`;
export type CreateReusableExhibitEntityMutationFn = Apollo.MutationFunction<
  Types.CreateReusableExhibitEntityMutation,
  Types.CreateReusableExhibitEntityMutationVariables
>;

/**
 * __useCreateReusableExhibitEntityMutation__
 *
 * To run a mutation, you first call `useCreateReusableExhibitEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReusableExhibitEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReusableExhibitEntityMutation, { data, loading, error }] = useCreateReusableExhibitEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReusableExhibitEntityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateReusableExhibitEntityMutation,
    Types.CreateReusableExhibitEntityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateReusableExhibitEntityMutation,
    Types.CreateReusableExhibitEntityMutationVariables
  >(CreateReusableExhibitEntityDocument, options);
}
export type CreateReusableExhibitEntityMutationHookResult = ReturnType<
  typeof useCreateReusableExhibitEntityMutation
>;
export type CreateReusableExhibitEntityMutationResult =
  Apollo.MutationResult<Types.CreateReusableExhibitEntityMutation>;
export type CreateReusableExhibitEntityMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreateReusableExhibitEntityMutation,
    Types.CreateReusableExhibitEntityMutationVariables
  >;
export const DeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdDocument = /*#__PURE__*/ gql`
  mutation DeleteReusableExhibitEntityByReusableExhibitIdAndEntityId(
    $input: DeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdInput!
  ) {
    deleteReusableExhibitEntityByReusableExhibitIdAndEntityId(input: $input) {
      clientMutationId
    }
  }
`;
export type DeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutationFn =
  Apollo.MutationFunction<
    Types.DeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutation,
    Types.DeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutationVariables
  >;

/**
 * __useDeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutation__
 *
 * To run a mutation, you first call `useDeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutation, { data, loading, error }] = useDeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutation,
    Types.DeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutation,
    Types.DeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutationVariables
  >(DeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdDocument, options);
}
export type DeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutationHookResult =
  ReturnType<
    typeof useDeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutation
  >;
export type DeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutationResult =
  Apollo.MutationResult<Types.DeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutation>;
export type DeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutationOptions =
  Apollo.BaseMutationOptions<
    Types.DeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutation,
    Types.DeleteReusableExhibitEntityByReusableExhibitIdAndEntityIdMutationVariables
  >;
export const DeleteReusableExhibitFileByReusableExhibitIdAndFileIdDocument = /*#__PURE__*/ gql`
  mutation DeleteReusableExhibitFileByReusableExhibitIdAndFileId(
    $input: DeleteReusableExhibitFileByReusableExhibitIdAndFileIdInput!
  ) {
    deleteReusableExhibitFileByReusableExhibitIdAndFileId(input: $input) {
      clientMutationId
      deletedReusableExhibitFileId
      reusableExhibitFile {
        nodeId
        fileId
        reusableExhibitId
        __typename
      }
      fileByFileId {
        id
        __typename
      }
      reusableExhibitByReusableExhibitId {
        id
        __typename
      }
    }
  }
`;
export type DeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutationFn =
  Apollo.MutationFunction<
    Types.DeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutation,
    Types.DeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutationVariables
  >;

/**
 * __useDeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutation__
 *
 * To run a mutation, you first call `useDeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReusableExhibitFileByReusableExhibitIdAndFileIdMutation, { data, loading, error }] = useDeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutation,
    Types.DeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutation,
    Types.DeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutationVariables
  >(DeleteReusableExhibitFileByReusableExhibitIdAndFileIdDocument, options);
}
export type DeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutationHookResult =
  ReturnType<
    typeof useDeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutation
  >;
export type DeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutationResult =
  Apollo.MutationResult<Types.DeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutation>;
export type DeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutationOptions =
  Apollo.BaseMutationOptions<
    Types.DeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutation,
    Types.DeleteReusableExhibitFileByReusableExhibitIdAndFileIdMutationVariables
  >;
export const UserByEmailDocument = /*#__PURE__*/ gql`
  query UserByEmail($email: String!) {
    allUsers(condition: { email: $email }, first: 1) {
      nodes {
        id
        fullName
        email
        userDatumById {
          phoneNumber
          role
        }
      }
    }
  }
`;

/**
 * __useUserByEmailQuery__
 *
 * To run a query within a React component, call `useUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserByEmailQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.UserByEmailQuery,
    Types.UserByEmailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.UserByEmailQuery,
    Types.UserByEmailQueryVariables
  >(UserByEmailDocument, options);
}
export function useUserByEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.UserByEmailQuery,
    Types.UserByEmailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.UserByEmailQuery,
    Types.UserByEmailQueryVariables
  >(UserByEmailDocument, options);
}
export type UserByEmailQueryHookResult = ReturnType<typeof useUserByEmailQuery>;
export type UserByEmailLazyQueryHookResult = ReturnType<
  typeof useUserByEmailLazyQuery
>;
export type UserByEmailQueryResult = Apollo.QueryResult<
  Types.UserByEmailQuery,
  Types.UserByEmailQueryVariables
>;
export const UserUpdatesDocument = /*#__PURE__*/ gql`
  mutation UserUpdates($input: UpdateUserByIdInput!) {
    updateUserById(input: $input) {
      user {
        bio
        email
        portalOnboarded
        fullName
        firstName
        middleName
        lastName
      }
    }
  }
`;
export type UserUpdatesMutationFn = Apollo.MutationFunction<
  Types.UserUpdatesMutation,
  Types.UserUpdatesMutationVariables
>;

/**
 * __useUserUpdatesMutation__
 *
 * To run a mutation, you first call `useUserUpdatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdatesMutation, { data, loading, error }] = useUserUpdatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserUpdatesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UserUpdatesMutation,
    Types.UserUpdatesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UserUpdatesMutation,
    Types.UserUpdatesMutationVariables
  >(UserUpdatesDocument, options);
}
export type UserUpdatesMutationHookResult = ReturnType<
  typeof useUserUpdatesMutation
>;
export type UserUpdatesMutationResult =
  Apollo.MutationResult<Types.UserUpdatesMutation>;
export type UserUpdatesMutationOptions = Apollo.BaseMutationOptions<
  Types.UserUpdatesMutation,
  Types.UserUpdatesMutationVariables
>;
export const UserDatumUpdatesDocument = /*#__PURE__*/ gql`
  mutation UserDatumUpdates($input: UpdateUserDatumByIdInput!) {
    updateUserDatumById(input: $input) {
      userDatum {
        id
        stateUsResidentialAddress
        streetNumberStreetNameForeignAddress
        streetNumberStreetNameUsResidentialAddress
        zipCodeUsResidentialAddress
        stateForeignAddress
        provinceForeignAddress
        provinceBirth
        postalCodeForeignAddress
        cityBirth
        cityForeignAddress
        countryBirth
        cityUsResidentialAddress
        countryForeignAddress
        phoneNumber
        role
        usRoleTitle
        addresses
      }
    }
  }
`;
export type UserDatumUpdatesMutationFn = Apollo.MutationFunction<
  Types.UserDatumUpdatesMutation,
  Types.UserDatumUpdatesMutationVariables
>;

/**
 * __useUserDatumUpdatesMutation__
 *
 * To run a mutation, you first call `useUserDatumUpdatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDatumUpdatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDatumUpdatesMutation, { data, loading, error }] = useUserDatumUpdatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserDatumUpdatesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UserDatumUpdatesMutation,
    Types.UserDatumUpdatesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UserDatumUpdatesMutation,
    Types.UserDatumUpdatesMutationVariables
  >(UserDatumUpdatesDocument, options);
}
export type UserDatumUpdatesMutationHookResult = ReturnType<
  typeof useUserDatumUpdatesMutation
>;
export type UserDatumUpdatesMutationResult =
  Apollo.MutationResult<Types.UserDatumUpdatesMutation>;
export type UserDatumUpdatesMutationOptions = Apollo.BaseMutationOptions<
  Types.UserDatumUpdatesMutation,
  Types.UserDatumUpdatesMutationVariables
>;
export const CreateUserDatumDocument = /*#__PURE__*/ gql`
  mutation CreateUserDatum($input: CreateUserDatumInput!) {
    createUserDatum(input: $input) {
      userDatum {
        id
        stateUsResidentialAddress
        streetNumberStreetNameForeignAddress
        streetNumberStreetNameUsResidentialAddress
        zipCodeUsResidentialAddress
        stateForeignAddress
        provinceForeignAddress
        provinceBirth
        postalCodeForeignAddress
        cityBirth
        cityForeignAddress
        countryBirth
        cityUsResidentialAddress
        countryForeignAddress
        phoneNumber
        role
      }
    }
  }
`;
export type CreateUserDatumMutationFn = Apollo.MutationFunction<
  Types.CreateUserDatumMutation,
  Types.CreateUserDatumMutationVariables
>;

/**
 * __useCreateUserDatumMutation__
 *
 * To run a mutation, you first call `useCreateUserDatumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserDatumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserDatumMutation, { data, loading, error }] = useCreateUserDatumMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserDatumMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateUserDatumMutation,
    Types.CreateUserDatumMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateUserDatumMutation,
    Types.CreateUserDatumMutationVariables
  >(CreateUserDatumDocument, options);
}
export type CreateUserDatumMutationHookResult = ReturnType<
  typeof useCreateUserDatumMutation
>;
export type CreateUserDatumMutationResult =
  Apollo.MutationResult<Types.CreateUserDatumMutation>;
export type CreateUserDatumMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateUserDatumMutation,
  Types.CreateUserDatumMutationVariables
>;
export const UpdateTeamDocument = /*#__PURE__*/ gql`
  mutation UpdateTeam($input: UpdateCompanyByIdInput!) {
    updateCompanyById(input: $input) {
      clientMutationId
    }
  }
`;
export type UpdateTeamMutationFn = Apollo.MutationFunction<
  Types.UpdateTeamMutation,
  Types.UpdateTeamMutationVariables
>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateTeamMutation,
    Types.UpdateTeamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateTeamMutation,
    Types.UpdateTeamMutationVariables
  >(UpdateTeamDocument, options);
}
export type UpdateTeamMutationHookResult = ReturnType<
  typeof useUpdateTeamMutation
>;
export type UpdateTeamMutationResult =
  Apollo.MutationResult<Types.UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateTeamMutation,
  Types.UpdateTeamMutationVariables
>;
export const CompanyByIdDocument = /*#__PURE__*/ gql`
  query CompanyById($id: BigInt!) {
    companyById(id: $id) {
      dbaName
      id
      bio
      portalOnboarded
      stateBusinessAddress
      streetNumberStreetNameBusinessAddress
      unitNumberBusinessAddress
      unitTypeBusinessAddress
      zipCodeBusinessAddress
      countryBusinessAddress
      cityBusinessAddress
      companyTypeOfBusiness
      currentNumberOfEmployees
      companyGrossAnnualIncome
      companyNetAnnualIncome
    }
  }
`;

/**
 * __useCompanyByIdQuery__
 *
 * To run a query within a React component, call `useCompanyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.CompanyByIdQuery,
    Types.CompanyByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.CompanyByIdQuery,
    Types.CompanyByIdQueryVariables
  >(CompanyByIdDocument, options);
}
export function useCompanyByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CompanyByIdQuery,
    Types.CompanyByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.CompanyByIdQuery,
    Types.CompanyByIdQueryVariables
  >(CompanyByIdDocument, options);
}
export type CompanyByIdQueryHookResult = ReturnType<typeof useCompanyByIdQuery>;
export type CompanyByIdLazyQueryHookResult = ReturnType<
  typeof useCompanyByIdLazyQuery
>;
export type CompanyByIdQueryResult = Apollo.QueryResult<
  Types.CompanyByIdQuery,
  Types.CompanyByIdQueryVariables
>;
export const ImmigrationDocsByUserDocument = /*#__PURE__*/ gql`
  query ImmigrationDocsByUser(
    $ownerId: BigInt!
    $type: ImmigrationDocumentType!
  ) {
    allImmigrationDocuments(
      condition: { type: $type, ownerId: $ownerId }
      orderBy: ORDER_INDEX_ASC
    ) {
      nodes {
        nodeId
        deleted
        fileByFileId {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useImmigrationDocsByUserQuery__
 *
 * To run a query within a React component, call `useImmigrationDocsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useImmigrationDocsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImmigrationDocsByUserQuery({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useImmigrationDocsByUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.ImmigrationDocsByUserQuery,
    Types.ImmigrationDocsByUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ImmigrationDocsByUserQuery,
    Types.ImmigrationDocsByUserQueryVariables
  >(ImmigrationDocsByUserDocument, options);
}
export function useImmigrationDocsByUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ImmigrationDocsByUserQuery,
    Types.ImmigrationDocsByUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ImmigrationDocsByUserQuery,
    Types.ImmigrationDocsByUserQueryVariables
  >(ImmigrationDocsByUserDocument, options);
}
export type ImmigrationDocsByUserQueryHookResult = ReturnType<
  typeof useImmigrationDocsByUserQuery
>;
export type ImmigrationDocsByUserLazyQueryHookResult = ReturnType<
  typeof useImmigrationDocsByUserLazyQuery
>;
export type ImmigrationDocsByUserQueryResult = Apollo.QueryResult<
  Types.ImmigrationDocsByUserQuery,
  Types.ImmigrationDocsByUserQueryVariables
>;
export const AllImmigrationDocsByUserDocument = /*#__PURE__*/ gql`
  query AllImmigrationDocsByUser($ownerId: BigInt!) {
    allImmigrationDocuments(
      condition: { ownerId: $ownerId }
      orderBy: ORDER_INDEX_ASC
    ) {
      nodes {
        nodeId
        type
        deleted
        fileByFileId {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useAllImmigrationDocsByUserQuery__
 *
 * To run a query within a React component, call `useAllImmigrationDocsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllImmigrationDocsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllImmigrationDocsByUserQuery({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *   },
 * });
 */
export function useAllImmigrationDocsByUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.AllImmigrationDocsByUserQuery,
    Types.AllImmigrationDocsByUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllImmigrationDocsByUserQuery,
    Types.AllImmigrationDocsByUserQueryVariables
  >(AllImmigrationDocsByUserDocument, options);
}
export function useAllImmigrationDocsByUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllImmigrationDocsByUserQuery,
    Types.AllImmigrationDocsByUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllImmigrationDocsByUserQuery,
    Types.AllImmigrationDocsByUserQueryVariables
  >(AllImmigrationDocsByUserDocument, options);
}
export type AllImmigrationDocsByUserQueryHookResult = ReturnType<
  typeof useAllImmigrationDocsByUserQuery
>;
export type AllImmigrationDocsByUserLazyQueryHookResult = ReturnType<
  typeof useAllImmigrationDocsByUserLazyQuery
>;
export type AllImmigrationDocsByUserQueryResult = Apollo.QueryResult<
  Types.AllImmigrationDocsByUserQuery,
  Types.AllImmigrationDocsByUserQueryVariables
>;
export const CompanyDocsByTypeDocument = /*#__PURE__*/ gql`
  query CompanyDocsByType($companyId: BigInt!, $type: CompanyDocumentType!) {
    allCompanyDocuments(condition: { type: $type, companyId: $companyId }) {
      nodes {
        visible
        fileByFileId {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useCompanyDocsByTypeQuery__
 *
 * To run a query within a React component, call `useCompanyDocsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDocsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDocsByTypeQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCompanyDocsByTypeQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.CompanyDocsByTypeQuery,
    Types.CompanyDocsByTypeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.CompanyDocsByTypeQuery,
    Types.CompanyDocsByTypeQueryVariables
  >(CompanyDocsByTypeDocument, options);
}
export function useCompanyDocsByTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CompanyDocsByTypeQuery,
    Types.CompanyDocsByTypeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.CompanyDocsByTypeQuery,
    Types.CompanyDocsByTypeQueryVariables
  >(CompanyDocsByTypeDocument, options);
}
export type CompanyDocsByTypeQueryHookResult = ReturnType<
  typeof useCompanyDocsByTypeQuery
>;
export type CompanyDocsByTypeLazyQueryHookResult = ReturnType<
  typeof useCompanyDocsByTypeLazyQuery
>;
export type CompanyDocsByTypeQueryResult = Apollo.QueryResult<
  Types.CompanyDocsByTypeQuery,
  Types.CompanyDocsByTypeQueryVariables
>;
export const AllCompanyDocsDocument = /*#__PURE__*/ gql`
  query AllCompanyDocs($companyId: BigInt!) {
    allCompanyDocuments(condition: { companyId: $companyId }) {
      nodes {
        type
        visible
        fileByFileId {
          id
          name
          deleted
        }
      }
    }
  }
`;

/**
 * __useAllCompanyDocsQuery__
 *
 * To run a query within a React component, call `useAllCompanyDocsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCompanyDocsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCompanyDocsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAllCompanyDocsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.AllCompanyDocsQuery,
    Types.AllCompanyDocsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllCompanyDocsQuery,
    Types.AllCompanyDocsQueryVariables
  >(AllCompanyDocsDocument, options);
}
export function useAllCompanyDocsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllCompanyDocsQuery,
    Types.AllCompanyDocsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllCompanyDocsQuery,
    Types.AllCompanyDocsQueryVariables
  >(AllCompanyDocsDocument, options);
}
export type AllCompanyDocsQueryHookResult = ReturnType<
  typeof useAllCompanyDocsQuery
>;
export type AllCompanyDocsLazyQueryHookResult = ReturnType<
  typeof useAllCompanyDocsLazyQuery
>;
export type AllCompanyDocsQueryResult = Apollo.QueryResult<
  Types.AllCompanyDocsQuery,
  Types.AllCompanyDocsQueryVariables
>;
export const AllCompanyDocsForBeneficiaryDocument = /*#__PURE__*/ gql`
  query AllCompanyDocsForBeneficiary($companyId: BigInt!) {
    allCompanyDocuments(condition: { companyId: $companyId, visible: true }) {
      nodes {
        type
        visible
        fileByFileId {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useAllCompanyDocsForBeneficiaryQuery__
 *
 * To run a query within a React component, call `useAllCompanyDocsForBeneficiaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCompanyDocsForBeneficiaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCompanyDocsForBeneficiaryQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAllCompanyDocsForBeneficiaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.AllCompanyDocsForBeneficiaryQuery,
    Types.AllCompanyDocsForBeneficiaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllCompanyDocsForBeneficiaryQuery,
    Types.AllCompanyDocsForBeneficiaryQueryVariables
  >(AllCompanyDocsForBeneficiaryDocument, options);
}
export function useAllCompanyDocsForBeneficiaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllCompanyDocsForBeneficiaryQuery,
    Types.AllCompanyDocsForBeneficiaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllCompanyDocsForBeneficiaryQuery,
    Types.AllCompanyDocsForBeneficiaryQueryVariables
  >(AllCompanyDocsForBeneficiaryDocument, options);
}
export type AllCompanyDocsForBeneficiaryQueryHookResult = ReturnType<
  typeof useAllCompanyDocsForBeneficiaryQuery
>;
export type AllCompanyDocsForBeneficiaryLazyQueryHookResult = ReturnType<
  typeof useAllCompanyDocsForBeneficiaryLazyQuery
>;
export type AllCompanyDocsForBeneficiaryQueryResult = Apollo.QueryResult<
  Types.AllCompanyDocsForBeneficiaryQuery,
  Types.AllCompanyDocsForBeneficiaryQueryVariables
>;
export const UpdateCompanyDocument = /*#__PURE__*/ gql`
  mutation UpdateCompany($input: UpdateCompanyByIdInput!) {
    updateCompanyById(input: $input) {
      company {
        id
      }
    }
  }
`;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<
  Types.UpdateCompanyMutation,
  Types.UpdateCompanyMutationVariables
>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateCompanyMutation,
    Types.UpdateCompanyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateCompanyMutation,
    Types.UpdateCompanyMutationVariables
  >(UpdateCompanyDocument, options);
}
export type UpdateCompanyMutationHookResult = ReturnType<
  typeof useUpdateCompanyMutation
>;
export type UpdateCompanyMutationResult =
  Apollo.MutationResult<Types.UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateCompanyMutation,
  Types.UpdateCompanyMutationVariables
>;
export const CreateCompanyOfficeDocument = /*#__PURE__*/ gql`
  mutation CreateCompanyOffice($input: CreateCompanyOfficeInput!) {
    createCompanyOffice(input: $input) {
      companyOffice {
        id
      }
    }
  }
`;
export type CreateCompanyOfficeMutationFn = Apollo.MutationFunction<
  Types.CreateCompanyOfficeMutation,
  Types.CreateCompanyOfficeMutationVariables
>;

/**
 * __useCreateCompanyOfficeMutation__
 *
 * To run a mutation, you first call `useCreateCompanyOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyOfficeMutation, { data, loading, error }] = useCreateCompanyOfficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyOfficeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateCompanyOfficeMutation,
    Types.CreateCompanyOfficeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateCompanyOfficeMutation,
    Types.CreateCompanyOfficeMutationVariables
  >(CreateCompanyOfficeDocument, options);
}
export type CreateCompanyOfficeMutationHookResult = ReturnType<
  typeof useCreateCompanyOfficeMutation
>;
export type CreateCompanyOfficeMutationResult =
  Apollo.MutationResult<Types.CreateCompanyOfficeMutation>;
export type CreateCompanyOfficeMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateCompanyOfficeMutation,
  Types.CreateCompanyOfficeMutationVariables
>;
export const GetCompanyDocument = /*#__PURE__*/ gql`
  query GetCompany($companyId: BigInt!, $count: Int!) {
    companyById(id: $companyId) {
      countryBusinessAddress
      stateBusinessAddress
      cityBusinessAddress
      streetNumberStreetNameBusinessAddress
      zipCodeBusinessAddress
      isBusinessAddressWorksite
      portalOnboarded
      unitTypeBusinessAddress
      unitNumberBusinessAddress
      companyMembersByCompanyId(last: $count) {
        nodes {
          companyId
          nodeId
          isAuthorizedSignatory
          userByUserId {
            fullName
            id
            email
            userDatumById {
              phoneNumber
              usRoleTitle
              role
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetCompanyQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetCompanyQuery,
    Types.GetCompanyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.GetCompanyQuery, Types.GetCompanyQueryVariables>(
    GetCompanyDocument,
    options
  );
}
export function useGetCompanyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetCompanyQuery,
    Types.GetCompanyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetCompanyQuery,
    Types.GetCompanyQueryVariables
  >(GetCompanyDocument, options);
}
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<
  typeof useGetCompanyLazyQuery
>;
export type GetCompanyQueryResult = Apollo.QueryResult<
  Types.GetCompanyQuery,
  Types.GetCompanyQueryVariables
>;
export const AllUserDocumentsByTypeDocument = /*#__PURE__*/ gql`
  query AllUserDocumentsByType(
    $userId: BigInt
    $documentType: IndividualDocumentType!
  ) {
    allUserDocuments(
      condition: { userId: $userId, documentType: $documentType }
    ) {
      nodes {
        documentType
        fileByFileId {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useAllUserDocumentsByTypeQuery__
 *
 * To run a query within a React component, call `useAllUserDocumentsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserDocumentsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUserDocumentsByTypeQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useAllUserDocumentsByTypeQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.AllUserDocumentsByTypeQuery,
    Types.AllUserDocumentsByTypeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AllUserDocumentsByTypeQuery,
    Types.AllUserDocumentsByTypeQueryVariables
  >(AllUserDocumentsByTypeDocument, options);
}
export function useAllUserDocumentsByTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AllUserDocumentsByTypeQuery,
    Types.AllUserDocumentsByTypeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AllUserDocumentsByTypeQuery,
    Types.AllUserDocumentsByTypeQueryVariables
  >(AllUserDocumentsByTypeDocument, options);
}
export type AllUserDocumentsByTypeQueryHookResult = ReturnType<
  typeof useAllUserDocumentsByTypeQuery
>;
export type AllUserDocumentsByTypeLazyQueryHookResult = ReturnType<
  typeof useAllUserDocumentsByTypeLazyQuery
>;
export type AllUserDocumentsByTypeQueryResult = Apollo.QueryResult<
  Types.AllUserDocumentsByTypeQuery,
  Types.AllUserDocumentsByTypeQueryVariables
>;
export const UserEmploymentByIdDocument = /*#__PURE__*/ gql`
  query UserEmploymentById($id: Int!) {
    userEmploymentById(id: $id) {
      id
      city
      companyName
      country
      endDate
      endDate
      isCurrent
      nodeId
      position
      position
      startDate
      userId
    }
  }
`;

/**
 * __useUserEmploymentByIdQuery__
 *
 * To run a query within a React component, call `useUserEmploymentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEmploymentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEmploymentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserEmploymentByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.UserEmploymentByIdQuery,
    Types.UserEmploymentByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.UserEmploymentByIdQuery,
    Types.UserEmploymentByIdQueryVariables
  >(UserEmploymentByIdDocument, options);
}
export function useUserEmploymentByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.UserEmploymentByIdQuery,
    Types.UserEmploymentByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.UserEmploymentByIdQuery,
    Types.UserEmploymentByIdQueryVariables
  >(UserEmploymentByIdDocument, options);
}
export type UserEmploymentByIdQueryHookResult = ReturnType<
  typeof useUserEmploymentByIdQuery
>;
export type UserEmploymentByIdLazyQueryHookResult = ReturnType<
  typeof useUserEmploymentByIdLazyQuery
>;
export type UserEmploymentByIdQueryResult = Apollo.QueryResult<
  Types.UserEmploymentByIdQuery,
  Types.UserEmploymentByIdQueryVariables
>;
export const UpdateUserEmploymentByIdDocument = /*#__PURE__*/ gql`
  mutation UpdateUserEmploymentById($input: UpdateUserEmploymentByIdInput!) {
    updateUserEmploymentById(input: $input) {
      userEmployment {
        userId
        companyName
        position
        endDate
        isCurrent
        nodeId
        position
        startDate
        endDate
        city
        country
      }
    }
  }
`;
export type UpdateUserEmploymentByIdMutationFn = Apollo.MutationFunction<
  Types.UpdateUserEmploymentByIdMutation,
  Types.UpdateUserEmploymentByIdMutationVariables
>;

/**
 * __useUpdateUserEmploymentByIdMutation__
 *
 * To run a mutation, you first call `useUpdateUserEmploymentByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserEmploymentByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserEmploymentByIdMutation, { data, loading, error }] = useUpdateUserEmploymentByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserEmploymentByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateUserEmploymentByIdMutation,
    Types.UpdateUserEmploymentByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateUserEmploymentByIdMutation,
    Types.UpdateUserEmploymentByIdMutationVariables
  >(UpdateUserEmploymentByIdDocument, options);
}
export type UpdateUserEmploymentByIdMutationHookResult = ReturnType<
  typeof useUpdateUserEmploymentByIdMutation
>;
export type UpdateUserEmploymentByIdMutationResult =
  Apollo.MutationResult<Types.UpdateUserEmploymentByIdMutation>;
export type UpdateUserEmploymentByIdMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateUserEmploymentByIdMutation,
    Types.UpdateUserEmploymentByIdMutationVariables
  >;
export const UpdateCompanyMemberByCompanyIdAndUserIdDocument = /*#__PURE__*/ gql`
  mutation UpdateCompanyMemberByCompanyIdAndUserId(
    $input: UpdateCompanyMemberByCompanyIdAndUserIdInput!
  ) {
    updateCompanyMemberByCompanyIdAndUserId(input: $input) {
      companyMember {
        userId
        companyId
        role
        isAuthorizedSignatory
      }
    }
  }
`;
export type UpdateCompanyMemberByCompanyIdAndUserIdMutationFn =
  Apollo.MutationFunction<
    Types.UpdateCompanyMemberByCompanyIdAndUserIdMutation,
    Types.UpdateCompanyMemberByCompanyIdAndUserIdMutationVariables
  >;

/**
 * __useUpdateCompanyMemberByCompanyIdAndUserIdMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMemberByCompanyIdAndUserIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMemberByCompanyIdAndUserIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMemberByCompanyIdAndUserIdMutation, { data, loading, error }] = useUpdateCompanyMemberByCompanyIdAndUserIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyMemberByCompanyIdAndUserIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateCompanyMemberByCompanyIdAndUserIdMutation,
    Types.UpdateCompanyMemberByCompanyIdAndUserIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateCompanyMemberByCompanyIdAndUserIdMutation,
    Types.UpdateCompanyMemberByCompanyIdAndUserIdMutationVariables
  >(UpdateCompanyMemberByCompanyIdAndUserIdDocument, options);
}
export type UpdateCompanyMemberByCompanyIdAndUserIdMutationHookResult =
  ReturnType<typeof useUpdateCompanyMemberByCompanyIdAndUserIdMutation>;
export type UpdateCompanyMemberByCompanyIdAndUserIdMutationResult =
  Apollo.MutationResult<Types.UpdateCompanyMemberByCompanyIdAndUserIdMutation>;
export type UpdateCompanyMemberByCompanyIdAndUserIdMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateCompanyMemberByCompanyIdAndUserIdMutation,
    Types.UpdateCompanyMemberByCompanyIdAndUserIdMutationVariables
  >;
export const CompanyMemberByCompanyIdAndUserIdDocument = /*#__PURE__*/ gql`
  query CompanyMemberByCompanyIdAndUserId(
    $companyId: BigInt!
    $userId: BigInt!
  ) {
    companyMemberByCompanyIdAndUserId(companyId: $companyId, userId: $userId) {
      companyId
      isAuthorizedSignatory
      userId
    }
  }
`;

/**
 * __useCompanyMemberByCompanyIdAndUserIdQuery__
 *
 * To run a query within a React component, call `useCompanyMemberByCompanyIdAndUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyMemberByCompanyIdAndUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyMemberByCompanyIdAndUserIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCompanyMemberByCompanyIdAndUserIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.CompanyMemberByCompanyIdAndUserIdQuery,
    Types.CompanyMemberByCompanyIdAndUserIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.CompanyMemberByCompanyIdAndUserIdQuery,
    Types.CompanyMemberByCompanyIdAndUserIdQueryVariables
  >(CompanyMemberByCompanyIdAndUserIdDocument, options);
}
export function useCompanyMemberByCompanyIdAndUserIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CompanyMemberByCompanyIdAndUserIdQuery,
    Types.CompanyMemberByCompanyIdAndUserIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.CompanyMemberByCompanyIdAndUserIdQuery,
    Types.CompanyMemberByCompanyIdAndUserIdQueryVariables
  >(CompanyMemberByCompanyIdAndUserIdDocument, options);
}
export type CompanyMemberByCompanyIdAndUserIdQueryHookResult = ReturnType<
  typeof useCompanyMemberByCompanyIdAndUserIdQuery
>;
export type CompanyMemberByCompanyIdAndUserIdLazyQueryHookResult = ReturnType<
  typeof useCompanyMemberByCompanyIdAndUserIdLazyQuery
>;
export type CompanyMemberByCompanyIdAndUserIdQueryResult = Apollo.QueryResult<
  Types.CompanyMemberByCompanyIdAndUserIdQuery,
  Types.CompanyMemberByCompanyIdAndUserIdQueryVariables
>;
export const UpdateCompanyOfficeByIdDocument = /*#__PURE__*/ gql`
  mutation UpdateCompanyOfficeById($input: UpdateCompanyOfficeByIdInput!) {
    updateCompanyOfficeById(input: $input) {
      companyOffice {
        id
        companyId
        label
      }
    }
  }
`;
export type UpdateCompanyOfficeByIdMutationFn = Apollo.MutationFunction<
  Types.UpdateCompanyOfficeByIdMutation,
  Types.UpdateCompanyOfficeByIdMutationVariables
>;

/**
 * __useUpdateCompanyOfficeByIdMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyOfficeByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyOfficeByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyOfficeByIdMutation, { data, loading, error }] = useUpdateCompanyOfficeByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyOfficeByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateCompanyOfficeByIdMutation,
    Types.UpdateCompanyOfficeByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateCompanyOfficeByIdMutation,
    Types.UpdateCompanyOfficeByIdMutationVariables
  >(UpdateCompanyOfficeByIdDocument, options);
}
export type UpdateCompanyOfficeByIdMutationHookResult = ReturnType<
  typeof useUpdateCompanyOfficeByIdMutation
>;
export type UpdateCompanyOfficeByIdMutationResult =
  Apollo.MutationResult<Types.UpdateCompanyOfficeByIdMutation>;
export type UpdateCompanyOfficeByIdMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateCompanyOfficeByIdMutation,
  Types.UpdateCompanyOfficeByIdMutationVariables
>;
export const UpdateOnboardingByIdDocument = /*#__PURE__*/ gql`
  mutation UpdateOnboardingById($input: UpdateOnboardingByIdInput!) {
    updateOnboardingById(input: $input) {
      onboarding {
        id
      }
    }
  }
`;
export type UpdateOnboardingByIdMutationFn = Apollo.MutationFunction<
  Types.UpdateOnboardingByIdMutation,
  Types.UpdateOnboardingByIdMutationVariables
>;

/**
 * __useUpdateOnboardingByIdMutation__
 *
 * To run a mutation, you first call `useUpdateOnboardingByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnboardingByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnboardingByIdMutation, { data, loading, error }] = useUpdateOnboardingByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOnboardingByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateOnboardingByIdMutation,
    Types.UpdateOnboardingByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateOnboardingByIdMutation,
    Types.UpdateOnboardingByIdMutationVariables
  >(UpdateOnboardingByIdDocument, options);
}
export type UpdateOnboardingByIdMutationHookResult = ReturnType<
  typeof useUpdateOnboardingByIdMutation
>;
export type UpdateOnboardingByIdMutationResult =
  Apollo.MutationResult<Types.UpdateOnboardingByIdMutation>;
export type UpdateOnboardingByIdMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateOnboardingByIdMutation,
  Types.UpdateOnboardingByIdMutationVariables
>;
export const CreateUserEmploymentDocument = /*#__PURE__*/ gql`
  mutation CreateUserEmployment($input: CreateUserEmploymentInput!) {
    createUserEmployment(input: $input) {
      userEmployment {
        id
        companyName
        position
        startDate
        endDate
        isCurrent
        salary
        salaryFrequency
        otherCompensation
        isFullTime
        hoursPerWeek
        userId
        companyId
        nodeId
      }
    }
  }
`;
export type CreateUserEmploymentMutationFn = Apollo.MutationFunction<
  Types.CreateUserEmploymentMutation,
  Types.CreateUserEmploymentMutationVariables
>;

/**
 * __useCreateUserEmploymentMutation__
 *
 * To run a mutation, you first call `useCreateUserEmploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserEmploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserEmploymentMutation, { data, loading, error }] = useCreateUserEmploymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserEmploymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateUserEmploymentMutation,
    Types.CreateUserEmploymentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateUserEmploymentMutation,
    Types.CreateUserEmploymentMutationVariables
  >(CreateUserEmploymentDocument, options);
}
export type CreateUserEmploymentMutationHookResult = ReturnType<
  typeof useCreateUserEmploymentMutation
>;
export type CreateUserEmploymentMutationResult =
  Apollo.MutationResult<Types.CreateUserEmploymentMutation>;
export type CreateUserEmploymentMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateUserEmploymentMutation,
  Types.CreateUserEmploymentMutationVariables
>;
export const UpdateUserEmploymentDocument = /*#__PURE__*/ gql`
  mutation UpdateUserEmployment($input: UpdateUserEmploymentByIdInput!) {
    updateUserEmploymentById(input: $input) {
      userEmployment {
        id
        city
        companyId
        companyName
        country
        endDate
        hoursPerWeek
        isCurrent
        isFullTime
        nodeId
        otherCompensation
        position
        salary
        salaryFrequency
        startDate
        userId
      }
    }
  }
`;
export type UpdateUserEmploymentMutationFn = Apollo.MutationFunction<
  Types.UpdateUserEmploymentMutation,
  Types.UpdateUserEmploymentMutationVariables
>;

/**
 * __useUpdateUserEmploymentMutation__
 *
 * To run a mutation, you first call `useUpdateUserEmploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserEmploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserEmploymentMutation, { data, loading, error }] = useUpdateUserEmploymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserEmploymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateUserEmploymentMutation,
    Types.UpdateUserEmploymentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateUserEmploymentMutation,
    Types.UpdateUserEmploymentMutationVariables
  >(UpdateUserEmploymentDocument, options);
}
export type UpdateUserEmploymentMutationHookResult = ReturnType<
  typeof useUpdateUserEmploymentMutation
>;
export type UpdateUserEmploymentMutationResult =
  Apollo.MutationResult<Types.UpdateUserEmploymentMutation>;
export type UpdateUserEmploymentMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateUserEmploymentMutation,
  Types.UpdateUserEmploymentMutationVariables
>;
export const UserEmploymentsDocument = /*#__PURE__*/ gql`
  query UserEmployments($petitionerId: BigInt!) {
    allUserEmployments(condition: { companyId: $petitionerId }) {
      nodes {
        nodeId
        id
        companyId
        companyName
        position
        startDate
        isCurrent
        salary
        salaryFrequency
        otherCompensation
        isFullTime
        hoursPerWeek
        userId
      }
    }
  }
`;

/**
 * __useUserEmploymentsQuery__
 *
 * To run a query within a React component, call `useUserEmploymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEmploymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEmploymentsQuery({
 *   variables: {
 *      petitionerId: // value for 'petitionerId'
 *   },
 * });
 */
export function useUserEmploymentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.UserEmploymentsQuery,
    Types.UserEmploymentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.UserEmploymentsQuery,
    Types.UserEmploymentsQueryVariables
  >(UserEmploymentsDocument, options);
}
export function useUserEmploymentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.UserEmploymentsQuery,
    Types.UserEmploymentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.UserEmploymentsQuery,
    Types.UserEmploymentsQueryVariables
  >(UserEmploymentsDocument, options);
}
export type UserEmploymentsQueryHookResult = ReturnType<
  typeof useUserEmploymentsQuery
>;
export type UserEmploymentsLazyQueryHookResult = ReturnType<
  typeof useUserEmploymentsLazyQuery
>;
export type UserEmploymentsQueryResult = Apollo.QueryResult<
  Types.UserEmploymentsQuery,
  Types.UserEmploymentsQueryVariables
>;
export const LoggedInUserDocument = /*#__PURE__*/ gql`
  query LoggedInUser {
    currentUserId
    isAdmin
  }
`;

/**
 * __useLoggedInUserQuery__
 *
 * To run a query within a React component, call `useLoggedInUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoggedInUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoggedInUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoggedInUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.LoggedInUserQuery,
    Types.LoggedInUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.LoggedInUserQuery,
    Types.LoggedInUserQueryVariables
  >(LoggedInUserDocument, options);
}
export function useLoggedInUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.LoggedInUserQuery,
    Types.LoggedInUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.LoggedInUserQuery,
    Types.LoggedInUserQueryVariables
  >(LoggedInUserDocument, options);
}
export type LoggedInUserQueryHookResult = ReturnType<
  typeof useLoggedInUserQuery
>;
export type LoggedInUserLazyQueryHookResult = ReturnType<
  typeof useLoggedInUserLazyQuery
>;
export type LoggedInUserQueryResult = Apollo.QueryResult<
  Types.LoggedInUserQuery,
  Types.LoggedInUserQueryVariables
>;
export const GetUserByIdDocument = /*#__PURE__*/ gql`
  query GetUserById($userId: BigInt!) {
    userById(id: $userId) {
      ...User
    }
  }
  ${UserFragmentDoc}
  ${UserDatumFragmentDoc}
`;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetUserByIdQuery,
    Types.GetUserByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetUserByIdQuery,
    Types.GetUserByIdQueryVariables
  >(GetUserByIdDocument, options);
}
export function useGetUserByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetUserByIdQuery,
    Types.GetUserByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetUserByIdQuery,
    Types.GetUserByIdQueryVariables
  >(GetUserByIdDocument, options);
}
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<
  typeof useGetUserByIdLazyQuery
>;
export type GetUserByIdQueryResult = Apollo.QueryResult<
  Types.GetUserByIdQuery,
  Types.GetUserByIdQueryVariables
>;
export const GetPetitionsByUserIdDocument = /*#__PURE__*/ gql`
  query GetPetitionsByUserId($id: BigInt!) {
    allPetitions(condition: { beneficiaryId: $id }) {
      nodes {
        ...Petition
      }
    }
  }
  ${PetitionFragmentDoc}
  ${ModuleFragmentDoc}
  ${ExhibitFragmentDoc}
`;

/**
 * __useGetPetitionsByUserIdQuery__
 *
 * To run a query within a React component, call `useGetPetitionsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPetitionsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPetitionsByUserIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPetitionsByUserIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetPetitionsByUserIdQuery,
    Types.GetPetitionsByUserIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetPetitionsByUserIdQuery,
    Types.GetPetitionsByUserIdQueryVariables
  >(GetPetitionsByUserIdDocument, options);
}
export function useGetPetitionsByUserIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetPetitionsByUserIdQuery,
    Types.GetPetitionsByUserIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetPetitionsByUserIdQuery,
    Types.GetPetitionsByUserIdQueryVariables
  >(GetPetitionsByUserIdDocument, options);
}
export type GetPetitionsByUserIdQueryHookResult = ReturnType<
  typeof useGetPetitionsByUserIdQuery
>;
export type GetPetitionsByUserIdLazyQueryHookResult = ReturnType<
  typeof useGetPetitionsByUserIdLazyQuery
>;
export type GetPetitionsByUserIdQueryResult = Apollo.QueryResult<
  Types.GetPetitionsByUserIdQuery,
  Types.GetPetitionsByUserIdQueryVariables
>;
export const GetPetitionsByCompanyIdDocument = /*#__PURE__*/ gql`
  query GetPetitionsByCompanyId($id: BigInt!) {
    allPetitions(condition: { petitionerId: $id }) {
      nodes {
        ...Petition
      }
    }
  }
  ${PetitionFragmentDoc}
  ${ModuleFragmentDoc}
  ${ExhibitFragmentDoc}
`;

/**
 * __useGetPetitionsByCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetPetitionsByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPetitionsByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPetitionsByCompanyIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPetitionsByCompanyIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetPetitionsByCompanyIdQuery,
    Types.GetPetitionsByCompanyIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetPetitionsByCompanyIdQuery,
    Types.GetPetitionsByCompanyIdQueryVariables
  >(GetPetitionsByCompanyIdDocument, options);
}
export function useGetPetitionsByCompanyIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetPetitionsByCompanyIdQuery,
    Types.GetPetitionsByCompanyIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetPetitionsByCompanyIdQuery,
    Types.GetPetitionsByCompanyIdQueryVariables
  >(GetPetitionsByCompanyIdDocument, options);
}
export type GetPetitionsByCompanyIdQueryHookResult = ReturnType<
  typeof useGetPetitionsByCompanyIdQuery
>;
export type GetPetitionsByCompanyIdLazyQueryHookResult = ReturnType<
  typeof useGetPetitionsByCompanyIdLazyQuery
>;
export type GetPetitionsByCompanyIdQueryResult = Apollo.QueryResult<
  Types.GetPetitionsByCompanyIdQuery,
  Types.GetPetitionsByCompanyIdQueryVariables
>;
export const PetitionByIdDocument = /*#__PURE__*/ gql`
  query PetitionById($petitionId: BigInt!) {
    petitionById(id: $petitionId) {
      ...Petition
    }
  }
  ${PetitionFragmentDoc}
  ${ModuleFragmentDoc}
  ${ExhibitFragmentDoc}
`;

/**
 * __usePetitionByIdQuery__
 *
 * To run a query within a React component, call `usePetitionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePetitionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetitionByIdQuery({
 *   variables: {
 *      petitionId: // value for 'petitionId'
 *   },
 * });
 */
export function usePetitionByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PetitionByIdQuery,
    Types.PetitionByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PetitionByIdQuery,
    Types.PetitionByIdQueryVariables
  >(PetitionByIdDocument, options);
}
export function usePetitionByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PetitionByIdQuery,
    Types.PetitionByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PetitionByIdQuery,
    Types.PetitionByIdQueryVariables
  >(PetitionByIdDocument, options);
}
export type PetitionByIdQueryHookResult = ReturnType<
  typeof usePetitionByIdQuery
>;
export type PetitionByIdLazyQueryHookResult = ReturnType<
  typeof usePetitionByIdLazyQuery
>;
export type PetitionByIdQueryResult = Apollo.QueryResult<
  Types.PetitionByIdQuery,
  Types.PetitionByIdQueryVariables
>;
export const PetitionBuilderPetitionByIdDocument = /*#__PURE__*/ gql`
  query PetitionBuilderPetitionById($petitionId: BigInt!) {
    petitionById(id: $petitionId) {
      id
      latestPetition
      companyByPetitionerId {
        dbaName
        id
      }
      petitionShippedDate
      status
      targetSubmissionDate
      uscisAddress
      trackingNumber
      uscisReceiptNumber
      uscisStatus
      userByBeneficiaryId {
        id
        fullName
      }
      caseType
      visaClass
      metadata
      modulesByPetitionId(orderBy: [ORDER_INDEX_ASC, ID_ASC]) {
        nodes {
          id
          name
          description
          type
          orderIndex
          exhibitsByModuleId(orderBy: [ORDER_INDEX_ASC, ID_ASC]) {
            nodes {
              ...Exhibit
            }
          }
        }
      }
    }
  }
  ${ExhibitFragmentDoc}
`;

/**
 * __usePetitionBuilderPetitionByIdQuery__
 *
 * To run a query within a React component, call `usePetitionBuilderPetitionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePetitionBuilderPetitionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetitionBuilderPetitionByIdQuery({
 *   variables: {
 *      petitionId: // value for 'petitionId'
 *   },
 * });
 */
export function usePetitionBuilderPetitionByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PetitionBuilderPetitionByIdQuery,
    Types.PetitionBuilderPetitionByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PetitionBuilderPetitionByIdQuery,
    Types.PetitionBuilderPetitionByIdQueryVariables
  >(PetitionBuilderPetitionByIdDocument, options);
}
export function usePetitionBuilderPetitionByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PetitionBuilderPetitionByIdQuery,
    Types.PetitionBuilderPetitionByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PetitionBuilderPetitionByIdQuery,
    Types.PetitionBuilderPetitionByIdQueryVariables
  >(PetitionBuilderPetitionByIdDocument, options);
}
export type PetitionBuilderPetitionByIdQueryHookResult = ReturnType<
  typeof usePetitionBuilderPetitionByIdQuery
>;
export type PetitionBuilderPetitionByIdLazyQueryHookResult = ReturnType<
  typeof usePetitionBuilderPetitionByIdLazyQuery
>;
export type PetitionBuilderPetitionByIdQueryResult = Apollo.QueryResult<
  Types.PetitionBuilderPetitionByIdQuery,
  Types.PetitionBuilderPetitionByIdQueryVariables
>;
export const TestSubDocument = /*#__PURE__*/ gql`
  subscription TestSub {
    testSubscription {
      id
    }
  }
`;

/**
 * __useTestSubSubscription__
 *
 * To run a query within a React component, call `useTestSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTestSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestSubSubscription({
 *   variables: {
 *   },
 * });
 */
export function useTestSubSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    Types.TestSubSubscription,
    Types.TestSubSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    Types.TestSubSubscription,
    Types.TestSubSubscriptionVariables
  >(TestSubDocument, options);
}
export type TestSubSubscriptionHookResult = ReturnType<
  typeof useTestSubSubscription
>;
export type TestSubSubscriptionResult =
  Apollo.SubscriptionResult<Types.TestSubSubscription>;
export const GetUserDatumByIdDocument = /*#__PURE__*/ gql`
  query GetUserDatumById($id: BigInt!) {
    userDatumById(id: $id) {
      addresses
      otherNames
    }
  }
`;

/**
 * __useGetUserDatumByIdQuery__
 *
 * To run a query within a React component, call `useGetUserDatumByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDatumByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDatumByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserDatumByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetUserDatumByIdQuery,
    Types.GetUserDatumByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetUserDatumByIdQuery,
    Types.GetUserDatumByIdQueryVariables
  >(GetUserDatumByIdDocument, options);
}
export function useGetUserDatumByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetUserDatumByIdQuery,
    Types.GetUserDatumByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetUserDatumByIdQuery,
    Types.GetUserDatumByIdQueryVariables
  >(GetUserDatumByIdDocument, options);
}
export type GetUserDatumByIdQueryHookResult = ReturnType<
  typeof useGetUserDatumByIdQuery
>;
export type GetUserDatumByIdLazyQueryHookResult = ReturnType<
  typeof useGetUserDatumByIdLazyQuery
>;
export type GetUserDatumByIdQueryResult = Apollo.QueryResult<
  Types.GetUserDatumByIdQuery,
  Types.GetUserDatumByIdQueryVariables
>;
export const OnboardingModuleTypesDocument = /*#__PURE__*/ gql`
  query OnboardingModuleTypes {
    allOnboardingModuleTypes {
      nodes {
        moduleType
        description
      }
    }
  }
`;

/**
 * __useOnboardingModuleTypesQuery__
 *
 * To run a query within a React component, call `useOnboardingModuleTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingModuleTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingModuleTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingModuleTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.OnboardingModuleTypesQuery,
    Types.OnboardingModuleTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.OnboardingModuleTypesQuery,
    Types.OnboardingModuleTypesQueryVariables
  >(OnboardingModuleTypesDocument, options);
}
export function useOnboardingModuleTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.OnboardingModuleTypesQuery,
    Types.OnboardingModuleTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.OnboardingModuleTypesQuery,
    Types.OnboardingModuleTypesQueryVariables
  >(OnboardingModuleTypesDocument, options);
}
export type OnboardingModuleTypesQueryHookResult = ReturnType<
  typeof useOnboardingModuleTypesQuery
>;
export type OnboardingModuleTypesLazyQueryHookResult = ReturnType<
  typeof useOnboardingModuleTypesLazyQuery
>;
export type OnboardingModuleTypesQueryResult = Apollo.QueryResult<
  Types.OnboardingModuleTypesQuery,
  Types.OnboardingModuleTypesQueryVariables
>;
export const GetCaseTypesDocument = /*#__PURE__*/ gql`
  query GetCaseTypes {
    allCaseTypes(orderBy: [NAME_ASC]) {
      nodes {
        id
        name
      }
    }
  }
`;

/**
 * __useGetCaseTypesQuery__
 *
 * To run a query within a React component, call `useGetCaseTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCaseTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GetCaseTypesQuery,
    Types.GetCaseTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetCaseTypesQuery,
    Types.GetCaseTypesQueryVariables
  >(GetCaseTypesDocument, options);
}
export function useGetCaseTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetCaseTypesQuery,
    Types.GetCaseTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetCaseTypesQuery,
    Types.GetCaseTypesQueryVariables
  >(GetCaseTypesDocument, options);
}
export type GetCaseTypesQueryHookResult = ReturnType<
  typeof useGetCaseTypesQuery
>;
export type GetCaseTypesLazyQueryHookResult = ReturnType<
  typeof useGetCaseTypesLazyQuery
>;
export type GetCaseTypesQueryResult = Apollo.QueryResult<
  Types.GetCaseTypesQuery,
  Types.GetCaseTypesQueryVariables
>;
export const GetVisaTypesDocument = /*#__PURE__*/ gql`
  query GetVisaTypes {
    allVisaTypes(orderBy: [VISA_TYPE_CODE_ASC]) {
      nodes {
        visaTypeCode
      }
    }
  }
`;

/**
 * __useGetVisaTypesQuery__
 *
 * To run a query within a React component, call `useGetVisaTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisaTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisaTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVisaTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GetVisaTypesQuery,
    Types.GetVisaTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetVisaTypesQuery,
    Types.GetVisaTypesQueryVariables
  >(GetVisaTypesDocument, options);
}
export function useGetVisaTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetVisaTypesQuery,
    Types.GetVisaTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetVisaTypesQuery,
    Types.GetVisaTypesQueryVariables
  >(GetVisaTypesDocument, options);
}
export type GetVisaTypesQueryHookResult = ReturnType<
  typeof useGetVisaTypesQuery
>;
export type GetVisaTypesLazyQueryHookResult = ReturnType<
  typeof useGetVisaTypesLazyQuery
>;
export type GetVisaTypesQueryResult = Apollo.QueryResult<
  Types.GetVisaTypesQuery,
  Types.GetVisaTypesQueryVariables
>;
export const SearchOnboardingByModuleDocument = /*#__PURE__*/ gql`
  query SearchOnboardingByModule($moduleId: String!, $exhibitId: String) {
    searchOnboardingByModule(moduleId: $moduleId, exhibitId: $exhibitId) {
      nodes {
        petitionByPetitionId {
          ...Petition
        }
      }
    }
  }
  ${PetitionFragmentDoc}
  ${ModuleFragmentDoc}
  ${ExhibitFragmentDoc}
`;

/**
 * __useSearchOnboardingByModuleQuery__
 *
 * To run a query within a React component, call `useSearchOnboardingByModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOnboardingByModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOnboardingByModuleQuery({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *      exhibitId: // value for 'exhibitId'
 *   },
 * });
 */
export function useSearchOnboardingByModuleQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SearchOnboardingByModuleQuery,
    Types.SearchOnboardingByModuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SearchOnboardingByModuleQuery,
    Types.SearchOnboardingByModuleQueryVariables
  >(SearchOnboardingByModuleDocument, options);
}
export function useSearchOnboardingByModuleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SearchOnboardingByModuleQuery,
    Types.SearchOnboardingByModuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SearchOnboardingByModuleQuery,
    Types.SearchOnboardingByModuleQueryVariables
  >(SearchOnboardingByModuleDocument, options);
}
export type SearchOnboardingByModuleQueryHookResult = ReturnType<
  typeof useSearchOnboardingByModuleQuery
>;
export type SearchOnboardingByModuleLazyQueryHookResult = ReturnType<
  typeof useSearchOnboardingByModuleLazyQuery
>;
export type SearchOnboardingByModuleQueryResult = Apollo.QueryResult<
  Types.SearchOnboardingByModuleQuery,
  Types.SearchOnboardingByModuleQueryVariables
>;
